/* Variabili globali */
window.isMobile = false;
window.isTablet = false;
window.isTabletPortrait = false;
window.isTabletLandscape = false;
window.isDesktop = false;
var formValidation = require('../components/formValidation');
var accessFocus = require('../accessibilityFocus');
const Modal = require('../modalUtilities');
var navigationCountry;
const _throttle = require('lodash/throttle');
const scrollAnimate = require('../components/scrollAnimate');
const CSRFUtil = require('../common/CSRFUtil');
var GrecaptchaV3 = require('../common/grecaptchaV3');

/* Funzioni Globali */
var responsiveResize = function () {
    if (window.matchMedia('(max-width: 767.98px)').matches) {
        $('body')
            .addClass('cc-mobile')
            .removeClass('cc-tablet')
            .removeClass('cc-tablet-portrait')
            .removeClass('cc-tablet-landscape')
            .removeClass('cc-desktop');
        window.isMobile = true;
        window.isTablet = false;
        window.isTabletPortrait = false;
        window.isTabletLandscape = false;
        window.isDesktop = false;
    } else if (window.matchMedia('(max-width: 1023.98px)').matches) {
        $('body')
            .removeClass('cc-mobile')
            .addClass('cc-tablet')
            .addClass('cc-tablet-portrait')
            .removeClass('cc-tablet-landscape')
            .removeClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = true;
        window.isTabletPortrait = true;
        window.isTabletLandscape = false;
        window.isDesktop = false;
    } else if (window.matchMedia('(max-width: 1199.98px)').matches) {
        $('body')
            .removeClass('cc-mobile')
            .addClass('cc-tablet')
            .addClass('cc-tablet-landscape')
            .removeClass('cc-tablet-portrait')
            .removeClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = true;
        window.isTabletPortrait = false;
        window.isTabletLandscape = true;
        window.isDesktop = false;
    } else {
        $('body')
            .removeClass('cc-mobile')
            .removeClass('cc-tablet')
            .removeClass('cc-tablet-portrait')
            .removeClass('cc-tablet-landscape')
            .addClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = false;
        window.isTabletPortrait = false;
        window.isTabletLandscape = false;
        window.isDesktop = true;
    }
    $('.js-touched').removeAttr('style');
    $('.js-touched').removeClass('js-touched');

    if ($('.js-header-banner').find('.cc-shipment-banner').length > 0) {
        var isSlider = $(document).find('.js-header-banner .js-banner-slider').length > 0 || $(document).find('.js-header-banner .js-banner-slider-fade').length > 0;
        if ($('.js-header-banner').hasClass('preload-gap') || isSlider) {
            var height = 0;
            if ($('body').hasClass('cc-mobile') || $('body').hasClass('cc-tablet-portrait')) {
                height = 81;
            } else {
                height = 139;
            }

            if (isSlider) {
                var banner = require('./bannerSlider');
                $('.js-header-banner').find('.js-banner-slider, .js-banner-slider-fade')
                    .on('init', function() {
                        $('.js-header').removeClass('sticky-for-a-while');
                        $('.js-header-banner').removeClass('preload-gap');
                        var heightBanner = $('.js-header-banner').height();
                        var tot = parseInt(height + heightBanner);
                        $('.js-header, :not(.cc-page-header-fixed)>.cc-content-header').css({ 'min-height': tot });
                    });
                banner.initializeBannerHeader();
            } else {
                $('.js-header').removeClass('sticky-for-a-while');
                $('.js-header-banner').removeClass('preload-gap');
                var heightBanner = $('.js-header-banner').height();
                var tot = parseInt(height + heightBanner);
                $('.js-header, :not(.cc-page-header-fixed)>.cc-content-header').css({ 'min-height': tot });
                // $(document).find('.cc-shipment-banner').css('display', 'block');
            }
        }
    } else {
        $('.js-header').removeClass('sticky-for-a-while');
    }

    if (window.isMobile) {
        $('.js-summary-button').attr('aria-disabled', false);
        $('.js-summary-button').attr('aria-expanded', false);
    } else {
        $('.js-summary-button').attr('aria-disabled', true);
        $('.js-summary-button').attr('aria-expanded', true);
    }

    // heightDevice();
};

var updateFooter = function () {
    if ($('body').hasClass('cc-mobile')) {
        $('.cc-col-title-button').attr('aria-disabled', false);
        $('.cc-col-title-button').attr('aria-expanded', false);
    } else {
        $('.cc-col-title-button').attr('aria-disabled', true);
        $('.cc-col-title-button').attr('aria-expanded', true);
    }
};

var updateNavMenu = function () {
    if (!$('.cc-header').hasClass('cc-header-checkout')) {
        $('.cc-mobile .cc-header .cc-button-menu-mobile, .cc-tablet-portrait .cc-header .cc-button-menu-mobile').removeClass('cc-open');
        $('.cc-mobile  .cc-navbar, .cc-tablet-portrait .cc-navbar').removeClass('cc-open');
        $('.cc-mobile .cc-navbar').css('display', 'none');
        $('.cc-tablet-portrait .cc-navbar').css('display', 'none');
        $('.helpButton, #embeddedMessagingConversationButton').css({
            display: 'block',
            visibility: 'visible'
        });
        $('body').removeClass('cc-blocked');
        $('body').removeClass('cc-megamenu-open');
        $('.js-header-banner').removeClass('cc-header-banner-hide');
        $('.cc-menu-overlay.js-menu-overlay').removeClass('cc-show-mobile, cc-hide-mobile');
        $('.cc-menu-overlay.js-menu-overlay').addClass('d-none');
        $('.cc-navbar-list').css('min-height', 0);
        $('.cc-button-menu-mobile').attr('aria-label', $('#js-openmenu-label').val());
    }
};

var resizeMiniCartModal = function () {
    var widthContent = $('.cc-minicart-pcard').width();
    if (!$('body').hasClass('cc-desktop')) {
        widthContent += 15;
    }
    $('.cc-minicart-footer').css({ width: widthContent });
    var heightFooter = $('.cc-minicart-footer').height();
    $('.cc-minicart-content').css({ 'padding-bottom': heightFooter });
};

function updateSizeList ($selector) {
    var url = $selector.data('url');
    var sku = $selector.data('id');
    var color = $selector.attr('data-color'); // data('color') retrieve old value
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        data: {
            sku: sku,
            color: color
        },
        success: function (data) {
            for (var i = 0; i < data.checkSize.length; i++) {
                var el = data.checkSize[i];
                var $input = $(document).find('#input-modalTile-size-' + sku + ' .js-checkavalability-' + sku + '-' + el.value);
                var $inputMobile = $(document).find('.size-list-mobile-tile-' + sku + ' .js-checkavalability-' + sku + '-' + el.value);
                var $label = $input.siblings('.js-select-size-tile');
                if (el.selectable) {
                    $input.removeAttr('disabled');
                    $label.removeClass('cc-size-no-available');
                    $inputMobile.removeClass('cc-size-list-text-mobile-no-available cc-size-no-available disabled');
                    $inputMobile.siblings('.cc-no-available-size-mobile').addClass('d-none');
                    if (el.isOnlyOneLeft) {
                        $inputMobile.siblings('.cc-only-one-left').removeClass('d-none');
                    } else {
                        $inputMobile.siblings('.cc-only-one-left').addClass('d-none');
                    }
                } else {
                    $input.attr('disabled');
                    $label.addClass('cc-size-no-available');
                    $inputMobile.addClass('cc-size-list-text-mobile-no-available cc-size-no-available disabled');
                    $inputMobile.siblings('.cc-no-available-size-mobile').removeClass('d-none');
                    $inputMobile.siblings('.cc-only-one-left').addClass('d-none');
                }
            }
            $.spinner().stop();
        }
    });
}

function openSizeColorModal() {
    $(document).on('click', '.js-open-size-color', function (event) {
        var $product = $(this).closest('.cc-product-tile');
        var $analytics = $('.new-analytics', $product);
        var masterPid = $analytics.attr('data-pid');
        var color = $analytics.attr('data-color');
        var id = $(this).data('id');
        var plus = $(this).data('plus');
        var minus = $(this).data('minus');
        updateSizeList($(this));
        $('.cc-size-color-modal').removeClass('cc-open');
        $('.js-change-icon').each(function() {
            $(this).children().attr('xlink:href', plus);
        });
        $('.js-close-size-color').removeClass('js-close-size-color').addClass('js-open-size-color');
        $(this).removeClass('js-open-size-color').addClass('js-close-size-color');
        if ($(document.body).hasClass('cc-mobile')) {
            $product.find($('.sizecolorTab-' + id)).addClass('js-mobileOverlay');
            $product.find($('.js-imageContainerWall-' + id)).attr('rel', $('.js-imageContainerWall-' + id).attr('href'));
            $product.find($('.js-imageContainerWall-' + id)).attr('href', 'javascript:;');

            $product.find($('.swatch-list-mobile-tile-' + id)).addClass('d-none');
            $product.find($('.open-swatch-list-' + id)).addClass('d-none');
            $product.find($('.close-swatch-list-' + id)).removeClass('d-none');
            $product.find($('.size-list-mobile-container-' + id)).removeClass('d-none');
            $product.find($('.open-size-list-' + id)).addClass('d-none');
            $product.find($('.close-size-list-' + id)).removeClass('d-none');
        }

        $(this).find('.js-size-color').attr('aria-expanded', true);

        $product.find($('.openTab-' + id)).find('use').attr('xlink:href', minus);

        $product.find($('.sizecolorTab-' + id)).addClass('cc-open');
        let parent = '.js-desktop-variant.sizecolorTab-' + id;
        setTimeout(() => {
            let maxWidthConsideringArrows = $product.find($(`${parent} .js-color-carousel-container:visible`)).width() - (35 * 2);
            let numberOfColors = parseInt(maxWidthConsideringArrows / 67);
            let numberOfAvailableColors = $product.find($(`${parent} .js-color-carousel-container:visible`)).data('numberOfColors');
            if (numberOfAvailableColors > numberOfColors && numberOfColors > 0) {
                if (!$(parent + ' .cc-swatch-container').hasClass('slick-initialized')) {
                    $(parent + ' .js-arrow-sx-color').removeClass('d-none');
                    $(parent + ' .js-arrow-dx-color').removeClass('d-none');
                    $(parent + ' .cc-swatch-container').css({ maxWidth: (maxWidthConsideringArrows - 10) + 'px', display: 'inline-block' });
                    $(parent + ' .cc-swatch-container').slick({
                        infinite: false,
                        slidesToScroll: 1,
                        slidesToShow: numberOfColors,
                        dots: false,
                        arrow: true,
                        prevArrow: parent + ' .js-arrow-sx-color',
                        nextArrow: parent + ' .js-arrow-dx-color'
                    });
                }
            } else {
                $product.find($(parent + ' .js-arrow-sx-color')).addClass('d-none');
                $product.find($(parent + ' .js-arrow-dx-color')).addClass('d-none');
            }
        }, 100);
        // focus on modal when open
        var selector;
        if (window.isMobile) {
            selector = '.hide-mobile-up.sizecolorTab-' + id;
        } else {
            selector = '.hide-mobile.sizecolorTab-' + id;
        }
        const FOCUSABLE = 'button:not(:disabled):not([aria-hidden]),[id*="input-modalTile-size-"] input,.input-modalTile-color ul button';
        $product.find($('.sizecolorTab-' + id)).attr('tabindex', '-1');
        $product.find($(selector)).find(FOCUSABLE).each(function() {
            if (!this.disabled && !$(this).hasClass('d-none') && !$(this).hasClass('js-arrow-sx-color') && !$(this).hasClass('js-arrow-dx-color')) {
                this.focus();
                return false;
            }
        });
        $product.find($(selector)).on('keydown', function(event) {
            let nodes = $(selector).find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
            var focusableNodes = [];
            $.each(nodes, function(i, val) {
                if (!this.disabled) {
                    focusableNodes.push(val);
                }
            });
            const key = event.which;
            const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
            if (event.shiftKey && focusedItemIndex === 0) {
                focusableNodes[focusableNodes.length - 1].focus();
                event.preventDefault();
            }
            if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1 && key !== 13) {
                // move focus out of the size modal, leaving it open
                $product.find($('.js-close-size-color[data-id="' + id + '"] .js-size-color')[0]).focus();
                event.preventDefault();
            }
            if (key === 27) { // close popUp on ESC
                $product.find($('.sizecolorTab-' + id)).removeClass('cc-open');
                $product.find($('.openTab-' + id)).find('.js-change-icon').children().attr('xlink:href', plus);
                $product.find($('.openTab-' + id)).removeClass('js-close-size-color').addClass('js-open-size-color');
                $product.find($('.openTab-' + id)).find('.js-size-color').attr('aria-expanded', false);
                setTimeout(function() {
                    $product.find($('.openTab-' + id + ' button')).focus();
                }, 0);
            }
        });
        event.stopPropagation();
        
        // auto select size if product has one size
        var $sizes = $('.cc-size-list:visible .js-add-size-product-analytics', $product);
        if ($sizes.length == 1) {
            $sizes.trigger('click');
        }

        $(document).trigger('analytics:dataLayerPushObj', {
            event: 'custom_event',
            eventCategory: 'Size Selector',
            eventAction: 'open',
            eventLabel: masterPid + color,  // pid concatenation tiles
            buttonType: 'Quick Cart Add',
            accessType: 'tile'
        });
    });
}

/**
 * experience module common to all
 */
var changeBackground = function (e) {
    if ($('body').find('.change-background').length > 0) {
        $(window).scroll(function() {
            var $window = $(window);
            var $body = $('body');
            var windowHeight = $window.height();
            var scrollOffset = windowHeight / 5;

            var $section = $('.change-background');

            var scrollStart = $window.scrollTop() + scrollOffset;
            var scrollEnd = $window.scrollTop() + windowHeight - scrollOffset;

            $body.css('background', '#fff');

            $section.each(function () {
                var $this = $(this);
                var className = $this.attr('class');
                var colorName = ('' + className).match(/.*change\-background\-(.*?)\s.*$/)[1];

                var sectionStart = $this.position().top;
                var sectionEnd = $this.position().top + $this.height();

                if ((sectionStart < scrollEnd) && (sectionEnd > scrollStart)) {
                    $body.css('background', '#' + colorName);
                }
            });
        }).scroll();
    };
};

/* 22 Slider */
var pdSlider = function () {
    if ($('.cc-pd-slider').length > 0) {
        if ($('.cc-pd-slider .cc-slider .slick-slide').length === 0) {
            $('.cc-pd-slider .cc-slider').each(function () {
                var configAutoplay = $(this).closest('.cc-pd-slider').data('config-autoplay');
                var sliderTimer = $(this).closest('.cc-pd-slider').data('config-speed');
                var $slidesContainer = $(this);

                $slidesContainer.slick({
                    infinite: true,
                    autoplay: true,
                    swipe: false,
                    focusOnSelect: false,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                    autoplaySpeed: sliderTimer,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    variableWidth: false,
                    dots: false,
                    arrow: true,
                    prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                    nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>'
                });

                // $slidesContainer.on('touchstart', e => {
                //     touched = true;
                //     $(this).slick('slickPlay');
                // });

                function progressBar() {
                    $('.cc-pd-slider').find('.cc-pd-slider-progress .cc-progress').removeAttr('style');
                    $('.cc-pd-slider').find('.cc-pd-slider-progress .cc-progress').removeClass('cc-active');
                    setTimeout(function() {
                        $('.cc-pd-slider').find('.cc-pd-slider-progress .cc-progress').css('transition-duration', ((sliderTimer + 400) / 1000) + 's');
                        $('.cc-pd-slider').find('.cc-pd-slider-progress .cc-progress').addClass('cc-active');
                    }, 100);
                }

                if (($(this).closest('.cc-pd-slider').find('.cc-pd-slider-progress .cc-progress').length > 0) && (configAutoplay === true)) {
                    progressBar();

                    $slidesContainer.on('beforeChange', function(e, slick) {
                        progressBar();
                    });
                }
            });
        }
    }
};

/* 35 Slider Progression */
var pdSliderProgression = function () {
    if ($('.cc-pd-slider-progression').length > 0) {
        if ($('.cc-pd-slider-progression .cc-slider .slick-slide').length === 0) {
            $('.cc-pd-slider-progression .cc-slider').each(function () {
                var $sliderModule = $(this).closest('.cc-pd-slider-progression');
                var sliderTimer = $sliderModule.data('config-speed');
                var $slidesContainer = $(this);

                $slidesContainer.slick({
                    infinite: true,
                    autoplay: false,
                    swipe: false,
                    focusOnSelect: false,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                    autoplaySpeed: sliderTimer,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    variableWidth: false,
                    dots: false,
                    arrow: false,
                    prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                    nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>'
                });

                var slideCount = $slidesContainer.find('.slick-slide:not(.slick-cloned)').length;

                var currentSlideIndex = $slidesContainer.slick('slickCurrentSlide');
                var $progressbar = $sliderModule.find('.cc-progressbar-active').eq(currentSlideIndex);
                var $promos = $slidesContainer.find('.slick-slide:not(.slick-cloned) .js-promo');
                var isPaused = false;
                var iterations = 0;
                var time = 150;

                const pauseInterval = function () {
                    isPaused = true;
                };

                const resumeInterval = function () {
                    iterations = 0;
                    isPaused = false;
                };

                var interval = setInterval(() => {
                    if (isPaused) return;

                    var width = (time / sliderTimer) * iterations * 100;
                    if (width <= 100) {
                        $progressbar.css('width', width + '%');
                        iterations++;
                    } else {
                        pauseInterval();

                        // change slide
                        currentSlideIndex = $slidesContainer.slick('slickCurrentSlide');
                        var nextSlideIndex = (currentSlideIndex + 1) % slideCount;
                        $slidesContainer.slick('slickGoTo', nextSlideIndex);

                        // clear progress for current progressbar
                        $progressbar.css('width', '');

                        // update progressbar to match next slide
                        $progressbar = $sliderModule.find('.cc-progressbar-active').eq(nextSlideIndex);

                        // resume interval
                        resumeInterval();
                    }
                }, time);

                // handle click events
                $sliderModule.on('click', '.cc-progression-item', function(e) {
                    var $cta = $(this).find('button.cc-item-label');
                    // if cta is visible and click is not on the cta or on the progresss bar, ignore click
                    if ($cta.is(':visible') && ! $(e.target).is('button.cc-item-label, .cc-progressbar')) return;
                    pauseInterval();
                    // get clicked slide index
                    var slideId = $(this).find('.cc-progressbar-active').data('progression-id');
                    var slideIndex = $slidesContainer.find('[data-slide-id='+ slideId +']').closest('.slick-slide').data('slick-index');

                    // remove progress from other progress bars
                    $sliderModule.find('.cc-progressbar-active').css('width', '');

                    // update slide and progressbar
                    $slidesContainer.slick('slickGoTo', slideIndex);
                    $progressbar = $sliderModule.find('.cc-progressbar-active').eq(slideIndex);
                    resumeInterval();
                });

                // handle click on arrows
                $sliderModule.on('click', '.slick-arrow', function() {
                    pauseInterval();
                    $sliderModule.one('afterChange', function(_, slide) {
                        // clear progress for current progressbar
                        $progressbar.css('width', '');

                        // update progressbar to match next slide
                        $progressbar = $sliderModule.find('.cc-progressbar-active').eq(slide.currentSlide);
                        resumeInterval();
                    });
                });

                // analytics
                $slidesContainer.on('afterChange', function(_, slick){
                    var position = slick.currentSlide;
                    var $promo = $promos.eq(position);
                    if ($promo.length && ! $promo.hasClass('alreadyPrint')) {
                        $(document).trigger('analytics:promoViewAutoSlider', [$promo, position+1]);
                    }
                });
                $(document).trigger('analytics:promoViewAutoSlider', [$promos.eq(0), 1]);
            });
        }
    }
};

/* 36 Slider Immersive */
var pdSliderImmersive = function () {
    if ($('.cc-pd-slider-immersive').length > 0) {
        window.history.scrollRestoration = 'manual';
        window.addEventListener('beforeunload', () => window.scrollTo(0, 0));

        if ($('.cc-pd-slider-immersive .cc-slider .slick-slide').length === 0) {
            $('.cc-pd-slider-immersive .cc-slider').each(function () {
                let $sliderModule = $(this).closest('.cc-pd-slider-immersive');
                let $slidesContainer = $(this);

                $slidesContainer.slick({
                    infinite: false,
                    autoplay: false,
                    swipe: true,
                    focusOnSelect: false,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    centerMode: false,
                    fade: true,
                    cssEase: 'linear',
                    autoplaySpeed: 0,
                    speed: 1300,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    variableWidth: false,
                    dots: false,
                    arrow: true,
                    prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                    nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>'
                });

                let moduleHeight = $sliderModule.height();
                let slideCount = $slidesContainer.find('.slick-slide:not(.slick-cloned)').length;
                let canChangeSlide = true;
                let $header = $('header.js-header');
                let scrollingDown;
                let scrollBlocked = false;
                let intersection = null
                let lastIntersection = null;

                // update numbers on slide change
                $sliderModule.find('.cc-numbers .cc-number--total').text(slideCount);
                $sliderModule.on('afterChange', function(_, slide) {
                    $sliderModule.find('.cc-numbers .cc-number--active').text(slide.currentSlide+1);
                });

                if (! window.isTablet) {
                    const scrollSlides = function (scrollingDown) {
                        if (! canChangeSlide) return;
                        let currSlideIndex = $slidesContainer.slick('slickCurrentSlide');
                        let nextSlideIndex = currSlideIndex + (scrollingDown ? 1: -1);
                        if (nextSlideIndex > -1 && nextSlideIndex < slideCount) {
                            // scroll slides
                            canChangeSlide = false;
                            $slidesContainer.slick('slickGoTo', nextSlideIndex);
                            setTimeout(() => canChangeSlide = true, 500);
                        } else {
                            // first or last slide reached. unlock scroll
                            $('body').removeClass('cc-blocked');
                            scrollBlocked = false;
                            if (scrollingDown) {
                                observer.disconnect();
                                lastIntersection = null;
                                $sliderModule.one('scroll-up', function(){
                                    observer.observe($sliderModule[0]);
                                });
                            } else {
                                observer.disconnect();
                                lastIntersection = null;
                                $sliderModule.one('scroll-down', function(){
                                    observer.observe($sliderModule[0]);
                                });
                            }
                        }
                    };

                    // scroll event listeners
                    $(document).on('wheel', function(e) {
                        scrollingDown = e.originalEvent.deltaY > 0;
                        if (scrollBlocked) {
                            scrollSlides(scrollingDown);
                        } else if (! scrollingDown) {
                            $sliderModule.trigger('scroll-up');
                        } else {
                            $sliderModule.trigger('scroll-down');
                        }
                    });

                    $(document).on('touchstart', function(start){
                        $(document).one('touchmove', function(move) {
                            scrollingDown = move.touches[0].clientY < start.touches[0].clientY;

                            if (scrollBlocked) {
                                scrollSlides(scrollingDown);
                            } else if (! scrollingDown) {
                                $sliderModule.trigger('scroll-up');
                            } else {
                                $sliderModule.trigger('scroll-down');
                            }
                        });
                    });

                    const onIntersect = function (entries) {
                        intersection = entries[0];
                        if (intersection.intersectionRatio < threshold) return;
                        if (! lastIntersection) lastIntersection = intersection;

                        // do not block scroll if scrolling past the module
                        if (lastIntersection.boundingClientRect.y > intersection.boundingClientRect.y && scrollingDown) return;
                        else if (lastIntersection.boundingClientRect.y < intersection.boundingClientRect.y && !scrollingDown) return;

                        $('body').addClass('cc-blocked');

                        // temporary block scroll on slides
                        canChangeSlide = false;
                        setTimeout(() => canChangeSlide = true, 750);

                        // document.body.classList.add('cc-blocked');
                        if (! scrollBlocked) lastIntersection = intersection;
                        scrollBlocked = true;
                        // center the slide
                        let headerHeight = $header.height();
                        $('body').css('touch-action', 'none');
                        setTimeout(() => {
                            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                            let clientTop = document.documentElement.clientTop || document.body.clientTop || 0;
                            let sliderTop = $sliderModule[0].getBoundingClientRect().top;
                            let offsetTop = sliderTop + scrollTop - clientTop;
                            $(document).scrollTop(offsetTop + moduleHeight/2 - window.innerHeight/2 -headerHeight/2);
                            setTimeout(() => {
                                $('body').css('touch-action', '');
                            }, 500);
                        }, 250);
                    };
                    let extraspace = (window.innerHeight - $sliderModule.height()) / 2;
                    extraspace = Math.max(extraspace - 1, 0);

                    let threshold = (window.innerHeight - $header.height()) / $sliderModule.height() - 0.005;
                    threshold = Math.min(threshold/1.5, 1);
                    let options = {
                        // threshold: [Math.min(threshold/1.5 -0.1, 0.9), Math.min(threshold/1.5, 1)],
                        threshold: threshold,
                        rootMargin: -$header.height() + 'px 0px 0px 0px'
                    };

                    let observer = new IntersectionObserver(onIntersect, options);
                    observer.observe($sliderModule[0]);
                }
            });
        }
    }
};

/* Checkout select address */
var lookRelativesSlider = function () {
    if ($('.cc-look-relatives-slider').length > 0) {
        if ($('.cc-look-relatives-slider .cc-slider .slick-slide').length === 0) {
            $('.cc-look-relatives-slider .cc-slider').each(function () {
                var slidesContainer = $(this);

                slidesContainer.slick({
                    infinite: true,
                    autoplay: false,
                    focusOnSelect: false,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 3,
                    slidesToShow: 3,
                    variableWidth: false,
                    dots: false,
                    arrow: true,
                    prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                    nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>',
                    responsive: [
                        {
                            breakpoint: 1199.98,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 767.98,
                            settings: {
                                slidesToShow: 2
                            }
                        }
                    ]
                });
            });
        }
    }
};

var sliderVariation = function () {
    // var arialabelPrev = $('.cc-product-list.cc-slider').data('arialabelprev');
    // var arialabelNext = $('.cc-product-list.cc-slider').data('arialabelnext');
    // var arrowNext = $('.cc-product-list.cc-slider').data('arrowdx');
    // var arrowPrev = $('.cc-product-list.cc-slider').data('arrowsx');
    if ($('.cc-product-list.cc-product-list-slider').length > 0) {
        if ($('.cc-product-list.cc-product-list-slider.slick-slide').length === 0) {
            $('.cc-product-list.cc-product-list-slider').each(function () {
                var slidesContainer = $(this);

                slidesContainer.slick({
                    accessibility: false,
                    infinite: false,
                    autoplay: false,
                    focusOnSelect: false,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: 3,
                    variableWidth: false,
                    dots: true,
                    dotsClass: 'slick-dots-line',
                    appendDots: $('.js-product-list-slick-dots'),
                    arrow: false,
                    prevArrow: null,
                    nextArrow: null,
                    responsive: [
                        {
                            breakpoint: 10000,
                            settings: 'unslick'
                        },
                        {
                            breakpoint: 767.98,
                            settings: {
                                slidesToScroll: 1,
                                slidesToShow: 3,
                                dots: false,
                                arrow: true,
                                infinite: false
                            }
                        }
                    ]
                });
            });
        }
    }
};

window.addEventListener('pageshow', (event) => {
    if (event.persisted || (window.performance.getEntriesByType('navigation').length && window.performance.getEntriesByType('navigation')[0].type === 'back_forward')) {
        if ($('.veil').length > 0 && !$('.veil').hasClass('hidden')) {
            $.spinner().stop();
        }
    }
});

/* Height device */
var initViewportHeight = function () {
    if ($('.cj-height-device').length > 0) {
        var height = $(window).innerHeight() - $('.cc-content-header').height();
        height = parseInt(height) + 'px';
        $('.cj-height-device').css('height', height);
    }
    if ($('.cc-page-designer-heder-fixed .cj-height-device').length > 0 && !$('body').hasClass('cc-mobile') && !$('body').hasClass('cc-tablet')) {
        var height = $(window).innerHeight();
        height = parseInt(height) + 'px';
        $('.cj-height-device').css('height', height);
    }
};
window.heightDevice = initViewportHeight;

var productBase = require('./../product/base');

function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

function setCookie (cookieName, value, expireDate) {
    var cookieExpiresDate = new Date();
    var addDays = parseInt(expireDate);
    cookieExpiresDate.setDate(cookieExpiresDate.getDate() + addDays);
    document.cookie = cookieName + '=' + String(value) + '; expires=' + cookieExpiresDate.toUTCString() + '; path=/';
}

function isSafari() {
    return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf('CriOS') == -1 &&
        navigator.userAgent.indexOf('FxiOS') == -1;
}

function liveChatEnable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'block',
        visibility: 'visible'
    });
};
function liveChatDisable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'none',
        visibility: 'hidden'
    });
}

function setButtonScrollDownPosition () {
    var heightHeader = $('.js-header').outerHeight();
    var heightContainerScrollDownArrow = $('.js-button-scroll-down').parent().outerHeight();
    if ($('.cc-page-header-fixed').length > 0 && window.innerWidth >= 1200) {
        if (heightContainerScrollDownArrow - window.innerHeight >= 0) {
            $('.js-button-scroll-down').css('bottom', (heightContainerScrollDownArrow) - window.innerHeight + 30 + 'px');
        } else {
            $('.js-button-scroll-down').css('bottom', '2rem');
        }
    } else if ((heightContainerScrollDownArrow + heightHeader) - window.innerHeight > 0) {
        $('.js-button-scroll-down').css('bottom', (heightContainerScrollDownArrow + heightHeader) - window.innerHeight + 30 + 'px');
    }
}

$(document).on('lazybeforeunveil', function(e) {
    let $element = $(e.target);
    let ajax = $element.data('video-url');
    if (!ajax) {
        return;
    }
    if ($element.hasClass('cloudinary')) {
        $element.setAttribute('src', ajax);
    } else {
        $.ajax({
            url: ajax,
            success: function(data) {
                $element.attr('src', data.videoURL);
            }
        });
    }
});
$(document).ready(function () {
    navigationCountry = $('.page').attr('data-navigation-country');
    if (navigationCountry === 'CN') {
        var TencentCaptcha = require('../common/tencentCaptcha');
    }
    if ($('.js-button-scroll-down').length > 0) {
        setButtonScrollDownPosition();
    }

    // Resize Window
    responsiveResize();
    updateFooter();
    updateHeaderHeightVariables();

    if (isSafari()) {
        $('body').addClass('cc-safari');
    }

    $(window).resize(function () {
        if ($('.js-button-scroll-down').length > 0) {
            setButtonScrollDownPosition();
        }
        responsiveResize();
        updateFooter();
        updateNavMenu();
        setTimeout(function() {
            resizeMiniCartModal();
        }, 200);
    });
    accessFocus.iterateFocusOnPage();
    // Selectpicker
    $.fn.selectpicker.Constructor.BootstrapVersion = '4';
    $('.selectpicker').selectpicker();
    $('.selectpicker').each(function() {
        $(this).css({
            display: 'none'
        });
        var label;
        // set button id for label
        if (this.labels.length > 0) {
            label = this.labels[0].innerText;
        } else {
            label = $(this).closest('.cc-form-group').find('.cc-label').html();
        }
        var $button = $(this).siblings('button');
        // var selectID = $(this).attr('id') + '_btn';
        // var labelID = $(this).attr('id') + '_lbl';
        // $(this).attr('aria-hidden', 'true');
        // $button.attr('id', selectID);
        var $dropdown = $button.siblings('.dropdown-menu').children('.inner');
        $dropdown.attr('aria-label', label);
        $button.attr('aria-label', label);
        $button.attr('role', 'combobox').attr('aria-activedescendant', '');
        $(this).selectpicker('refresh');
        // fix voice over
        $(this).parent().find('.dropdown-toggle').attr('tabindex', '0');
    });
    $('.dropdown-menu .inner').removeAttr('aria-activedescendant');

    var targets = $('button.dropdown-toggle').siblings('.dropdown-menu').children('.inner').removeAttr('aria-activedescendant').get();
    if (targets) {
        // create an observer instance
        targets.forEach(function(target) {
            var observer = new MutationObserver(function(mutations) {
                if (mutations.length) {
                    $(target).removeAttr('aria-activedescendant');
                    // disconnect `observer`
                    // this.disconnect();
                }
            });
            var config = {
                attributes: true
            };

            // pass in the target node, as well as the observer options
            observer.observe(target, config);
        });
    };
    // $.fn.selectpicker.Constructor.DEFAULTS.template.caret = '<div class=\"cc-content-arrow\"><div class=\"cc-svg cc-svg-select-arrow-down\"><span></span></div></div>';
    // cambio colore title dropdown
    $(document).on('change', '.cc-content-select-color .cc-select', function () {
        $(this).closest('.cc-content-select-color').removeClass('cc-content-select-color');
    });

    function updateHeaderHeightVariables() {
        var headerHeight = Math.ceil($('header').outerHeight());
        var bannerHeigth = Math.ceil($('header .js-header-banner').outerHeight() || 0);
        var topHeaderHeight = headerHeight - bannerHeigth;
        $('body').css('--header-height', `${headerHeight}px`).css('--header-top-height', `${topHeaderHeight}px`);
    }

    $(document).on('product:updatePrices', function(_, ...productIds){
        var url = $('.getProductPriceURL').val();
        productIds.forEach(function(pid) {
            $.ajax({
                url: url,
                method: 'GET',
                data: {
                    pid: pid
                },
                success: function(data) {
                    if (data.priceHTML) {
                        var $updatedPrice = $(data.priceHTML);
                        $updatedPrice.attr('data-price-updated', true);
                        var productId = $updatedPrice.attr('data-pid');
                        var $pricesToUpdate = $(`.cc-price.js-price[data-pid="${productId}"]`);
                        $updatedPrice.replaceAll($pricesToUpdate);
                    }
                }
            });
        });
    });

    // Sticky Header
    $(document).on('scroll', _throttle(function() {
        var $phoneHeader = $('.js-phone-header');
        if ($(window).scrollTop() > 86) {
            if (!$('body.cc-desktop').hasClass('body-horizontal-scroll')) {
                $('.cc-content-header .cc-header:not(.js-header-newpdp)').addClass('cc-header-sticky');
                $('body').trigger('headerSticky:true');
                $('.cc-navbar-list').css('content-visibility', 'visible');
                $('.js-button-scroll-down').hide();
                if ($('.cc-navbar-item').length > 6) {
                    $phoneHeader.find('.cc-text').attr('style', 'display:none !important');
                } else $phoneHeader.find('.cc-text').attr('style', '');
            }
        } else {
            $('.cc-content-header .cc-header:not(.js-header-newpdp)').removeClass('cc-header-sticky');
            $('body').trigger('headerSticky:false');
            $('.js-button-scroll-down').show();
            $phoneHeader.find('.cc-text').attr('style', '');
        }
        updateHeaderHeightVariables();
    }, 150));
    // PDP Share button
    $(document).on('click', '.cc-desktop .cc-product-detail .cc-share-button-share, .cc-tablet .cc-product-detail .cc-share-button-share', function (e) {
        $(this).find('.cc-share-overlay').fadeIn();
        $(this).addClass('cc-share-background-overlay');
        accessFocus.focusOnFirstElement('.cc-share-overlay');
        accessFocus.focuseOnModal('.cc-share-overlay', '.cc-share-button-share', '.cc-share-overlay');
        e.stopPropagation();
    });

    $(document).on('click', '.cc-mobile .cc-product-detail .cc-share-button-share', function (e) {
        $('.js-whatsapp-link').attr('href', function() { this.href = this.href.replace('https://wa.me/?text=', 'whatsapp://send?text='); });
        $('body').css('overflow', 'hidden');
        $('.cc-mobile-content-share').css('display', 'block');
        $('.cc-sticky-add-to-cart').css('display', 'none');

        var heightSocialHead = 75;
        var top;
        var headerHeight = $('header').height();
        var heightPage = $(window).height();
        if (heightPage < 550) {
            top = headerHeight + heightSocialHead;
        } else {
            var heightSocialListLink = $('div.cc-social-list').height();
            var heightSocialListUl = $('.cc-social-list-ul').height();
            var heightSocialList = heightSocialListUl + heightSocialListLink;
            top = heightPage - heightSocialList - heightSocialHead;
        }
        $('.cc-mobile-content-share').css('top', top);
        $(this).addClass('cc-share-background-overlay');
        e.stopPropagation();
        $('.helpButton, #embeddedMessagingConversationButton').css({
            display: 'none',
            visibility: 'hidden'
        });
    });
    $(document).on('click', '.cc-mobile .cc-product-detail .cc-qrcode-overlay', function (e) {
        $('.qrcode').removeClass('qrcode-active');
        $('.cc-qrcode-overlay').removeClass('cc-overlay-active');
    });
    $(document).on('click', '.cc-mobile .wechatShareMobile', function (e) {
        e.preventDefault();
        $('.qrcode').addClass('qrcode-active');
        $('.cc-qrcode-overlay').addClass('cc-overlay-active');
    });
    $(document).on('click', '.cc-product-detail .cc-mobile-content-share .cc-mobile-close-share-button', function (e) {
        $('.cc-mobile-content-share').css('display', 'none');
        $('.cc-sticky-add-to-cart').css('display', 'unset');
        $('.cc-share-button-share').removeClass('cc-share-background-overlay');
        var copyLink = $('.js-link-label').data('copy');
        $('.js-link-label').find('.js-social-text').text(copyLink);
        $('body').css('overflow', 'unset');
        e.stopPropagation();
        $('.helpButton, #embeddedMessagingConversationButton').css({
            display: 'block',
            visibility: 'visible'
        });
    });

    $(document).on('click', '.cc-product-detail .cc-share-button-share .cc-close-overlay-share-button', function (e) {
        $(this).closest('.cc-share-overlay').fadeOut();
        $(this).closest('.cc-share-button-share').removeClass('cc-share-background-overlay');
        var copyLink = $('.js-link-label').data('copy');
        $('.js-link-label').find('.js-social-text').text(copyLink);
        e.stopPropagation();
    });

    // valorizza aria-label in selectpicker

    // var select = $(document).find('.dropdown .dropdown-toggle');
    // select.each(function() {
    //     var title = $(this).attr('title');
    //     $(this).attr('aria-label', title);
    // });
    $(document).on('change', 'select', function() {
        var select = $(this).closest('.dropdown').find('.dropdown-toggle');
        var title = select.attr('title');
        select.attr('aria-label', title);
    });

    // Collapsable section
    $(document).on('click', '.cc-collapsable .cc-collapsable-button', function (e) {
        if ($(this).data('id-collapsable')) {
            var id = $(this).data('id-collapsable');
            $(this).toggleClass('cc-collapsable-close');
            $(this).closest('.cc-collapsable').find('.cc-collapsable-section').filter(function () {
                return ($(this).data('id-collapsable') && $(this).data('id-collapsable') === id);
            }).slideToggle();
            if (($(this).find('.js-expand-button').length > 0)) {
                if (!$(this).hasClass('cc-collapsable-close')) {
                    $(this).find('.js-expand-button').attr('aria-expanded', true);
                } else {
                    $(this).find('.js-expand-button').attr('aria-expanded', false);
                }
            }
        }
        e.stopPropagation();
    });

    // Collapsable section Summary
    $(document).on('click', '.cc-mobile .cj-summary-mobile-collapsable .cc-summary-header', function (e) {
        $(this).toggleClass('cc-open');
        if ($('.cc-summary-total-mobile').css('display') === 'block') {
            $('.cc-summary-total-mobile').css('display', 'none');
        } else {
            $('.cc-summary-total-mobile').css('display', 'block');
        }
        if ($(this).hasClass('cc-open')) {
            $('.cc-icon-down').addClass('d-none');
            $('.cc-icon-up').removeClass('d-none');
            $('.js-summary-button').attr('aria-expanded', true);
        } else {
            $('.cc-icon-up').addClass('d-none');
            $('.cc-icon-down').removeClass('d-none');
            $('.js-summary-button').attr('aria-expanded', false);
        }
        $(this).closest('.cj-summary-mobile-collapsable').find('.cc-summary-body').slideToggle();
        e.stopPropagation();
    });

    // Size Guide Info
    $(document).on('click', '.cc-size-guide .cc-content-size-columns .cc-content-table .cc-size-table .cc-size-info .cc-icon', function (e) {
        $(this).closest('.cc-content-size-columns').find('.cc-img-section').addClass('cc-open');
        e.stopPropagation();
    });
    $(document).on('click', '.cc-size-guide .cc-content-size-columns .cc-img-section', function (e) {
        $(this).removeClass('cc-open');
        e.stopPropagation();
    });

    // Size Guide accordion
    $(document).on('click', '.cc-size-guide-standard .cc-size-table .cc-row .cc-col.cc-col-1', function (e) {
        $(this).closest('.cc-row').toggleClass('cc-section-open');
        e.stopPropagation();
    });

    // Cart accordion
    $(document).on('click', '.cc-tax-accordion .cc-accordion-button', function (e) {
        $(this).toggleClass('cc-open');
        $(this).closest('.cc-tax-accordion').find('.cc-accordion-section').slideToggle();
        e.stopPropagation();
    });

    // Footer page Collapsable menu mobile
    $(document).on('click', '.cc-mobile .cc-footer-page .cc-content-lateral-menu .cc-button-lateral-menu', function (e) {
        $(this).toggleClass('cc-open');
        $(this).closest('.cc-content-lateral-menu').find('.cc-lateral-menu').slideToggle();
        e.stopPropagation();
    });

    // Footer page Active item link on onepage scroll
    if ($('.cc-footer-page .cc-lateral-menu-onepage').length > 0) {
        var lateralMenu = $('.cc-footer-page .cc-lateral-menu-onepage');
        var menuItems = lateralMenu.find('a');
        var scrollItems = menuItems.map(function() {
            var item = $($(this).attr('href'));
            if (item.length) { return item; }
        });
    }

    // experience: trigger definition to process background from an external ajax request after onload
    $('body').on('experience:changebackground', changeBackground);

    $(document).on('scroll', function () {
        if ($('.cc-footer-page .cc-lateral-menu-onepage').length > 0) {
            var fromTop = $(window).scrollTop() + 20;

            // Get id of current scroll item
            var cur = scrollItems.map(function() {
                if ($(this).offset().top < fromTop) { return this; }
            });
            // Get the id of the current element
            cur = cur[cur.length - 1];
            var id = cur && cur.length ? cur[0].id : '';
            // Set/remove active class
            menuItems
                .parent().removeClass('cc-active')
                .end().filter("[href='#" + id + "']").parent().addClass('cc-active');
        }
    });

    // Footer page Collapsable section
    $(document).on('click', '.cc-footer-page .cc-section .cc-collapsable-button', function (e) {
        $(this).toggleClass('cc-open');
        $(this).closest('.cc-collapsable-section').find('.cc-collapsable-main').slideToggle();
        e.stopPropagation();
    });

    // Footer Accordion Mobile
    $(document).on('click', '.cc-mobile .cc-footer .cc-footer-items .cc-col-title', function (e) {
        if ($(this).data('id-footer-menu-item')) {
            var id = $(this).data('id-footer-menu-item');
            $(this).toggleClass('cc-link-open');
            $(this).closest('.cc-footer-col').find('.cc-footer-links').filter(function () {
                return ($(this).data('id-footer-menu-item') && $(this).data('id-footer-menu-item') === id);
            }).slideToggle();

            if ($(this).hasClass('cc-link-open')) {
                $(this).children('.cc-col-title-button').attr('aria-expanded', true);
            } else {
                $(this).children('.cc-col-title-button').attr('aria-expanded', false);
            }
        }
        e.stopPropagation();
    });

    // Return Sidebar Collapsable section
    $(document).on('click', '.cc-return-sidebar .cc-collapsable-button', function (e) {
        $(this).toggleClass('cc-open');
        $(this).closest('.cc-collapsable-section').find('.cc-collapsable-main').slideToggle();

        if ($(this).hasClass('cc-open')) {
            $(this).find('.js-return-accordion').attr('aria-expanded', true);
        } else {
            $(this).find('.js-return-accordion').attr('aria-expanded', false);
        }
        e.stopPropagation();
    });

    // heightDevice();
    // prodColorSliderSticky();
    // addressSlider();
    pdSlider();
    pdSliderProgression();
    pdSliderImmersive();
    lookRelativesSlider();
    sliderVariation();

    openSizeColorModal();

    // closeSizeColorModal
    $(document).on('click', '.js-close-size-color', function () {
        var $product = $(this).closest('.cc-product-tile');
        var $analytics = $('.new-analytics', $product);
        var masterPid = $analytics.attr('data-pid');
        var color = $analytics.attr('data-color');
        var id = $(this).data('id');
        $(this).removeClass('js-close-size-color').addClass('js-open-size-color');
        $('.sizecolorTab-' + id).removeClass('cc-open');
        $(this).find('.js-size-color').attr('aria-expanded', false);

        var plus = $(this).data('plus');
        $('.openTab-' + id).find('.js-change-icon').children().attr('xlink:href', plus);
        $(document).trigger('analytics:dataLayerPushObj', {
            event: 'custom_event',
            eventCategory: 'Size Selector',
            eventAction: 'close',
            eventLabel: masterPid + color,  // pid concatenation tiles
            buttonType: 'Quick Cart Add',
            accessType: 'tile'
        });
    });

    // quickAddPLP
    $(document).on('click', '.js-buy-button-plp', function (e) {
        var prodID = $(this).attr('data-pid');
        var incompleteSelection = $(this).data('disabled');
        var isCart = $(document).find('.cc-cart');
        var addToCartUrl;
        var reupload = $('.js-goToCart-recommendad').val();
        if (incompleteSelection) {
            $('.js-available-size-title-' + prodID).css('color', '#922222');
            $('.error-select-size-' + prodID).removeClass('d-none');
            // accessibility: announce to select a size
            $('.error-select-size-' + prodID).append(' ');
        } else {
            if (isCart.length > 0) {
                addToCartUrl = getAddToCartUrl();
                productBase.performAddToCartCall(addToCartUrl, prodID, null, [], 1,
                    function (resData) {
                        $('body').trigger('product:afterAddToCart', resData);
                        window.location.reload();
                    },
                    function() {window.location.reload();}
                );
                e.preventDefault();
            } else {
                addToCartUrl = getAddToCartUrl();
                $('body').trigger('product:beforeAddToCart', this);
                $(document).find('.js-minicartside-overlay-container').css('content-visibility', 'visible');
                // call add to Cart function
                let $container = $(this).closest('.product');
                productBase.performAddToCartCall(addToCartUrl, prodID, null, [], 1, function (resData) {
                    $('.js-size-color-modal', $container).removeClass('cc-open');
                    let $element = $container.find('.js-close-size-color').removeClass('js-close-size-color').addClass('js-open-size-color');
                    let plus = $element.data('plus');
                    $element.find('use').attr('xlink:href', plus);
                    $('body').trigger('product:afterAddToCart', resData);
                }, function() {
                });
            }
        }
    });

    // openSwatchListMobile: function () {
    $(document).on('click', '.mobile-swatch-list', function () {
        var productID = $(this).data('pid');
        var container = $(this).closest($('.cc-size-color-modal'));
        if ($('.swatch-list-mobile-tile-' + productID, container).hasClass('d-none')) {
            // open swatch color
            $('.swatch-list-mobile-tile-' + productID, container).removeClass('d-none');
            $('.open-swatch-list-' + productID, container).removeClass('d-none');
            $('.close-swatch-list-' + productID, container).addClass('d-none');
            // if is open close sizeList
            if (!$('.size-list-mobile-container-' + productID, container).hasClass('d-none')) {
                $('.size-list-mobile-container-' + productID, container).addClass('d-none');
                $('.open-size-list-' + productID, container).removeClass('d-none');
                $('.close-size-list-' + productID, container).addClass('d-none');
            }

            let parent = `.sizecolorTab-${productID}.js-mobile-variant`;
            setTimeout(() => {
                let numberOfColors = parseInt(($(`.js-mobile-variant.sizecolorTab-${productID} .js-color-carousel-container`).width() - (16 * 2)) / 67);
                let numberOfAvailableColors = $(`.js-desktop-variant.sizecolorTab-${productID} .js-color-carousel-container`).data('numberOfColors');
                if (numberOfAvailableColors > numberOfColors && numberOfColors > 0) {
                    $(parent + ' .js-arrow-sx-color').removeClass('d-none');
                    $(parent + ' .js-arrow-dx-color').removeClass('d-none');
                    if (!$(parent + ' .cc-swatch-container').hasClass('slick-initialized')) {
                        var iteamWidth = $(parent + ' .cc-rectangle-color').width();
                        $(parent + ' .cc-swatch-container').css({ maxWidth: ((numberOfColors * iteamWidth) - 32) + 'px', display: 'inline-block' });
                        $(parent + ' .cc-swatch-container').slick({
                            infinite: false,
                            slidesToScroll: 1,
                            slidesToShow: numberOfColors,
                            dots: false,
                            arrow: true,
                            prevArrow: parent + ' .js-arrow-sx-color',
                            nextArrow: parent + ' .js-arrow-dx-color'
                        });
                    }
                } else {
                    $(parent + ' .js-arrow-sx-color').addClass('d-none');
                    $(parent + ' .js-arrow-dx-color').addClass('d-none');
                }
            }, 100);
        } else {
            // closing swatch color
            $('.swatch-list-mobile-tile-' + productID).addClass('d-none');
            $('.open-swatch-list-' + productID).addClass('d-none');
            $('.close-swatch-list-' + productID).removeClass('d-none');
        }
    });
    // },

    $(document).on('click', '.cc-mobile-size-list', function () {
        var productID = $(this).data('pid');
        var $sizeContainer = $(`.size-list-mobile-tile-${productID} .cc-size-list-mobile`);
        if ($sizeContainer.hasClass('d-none')) {
            // open size list
            $sizeContainer.removeClass('d-none');
            $('.open-size-list-' + productID).addClass('d-none');
            $('.close-size-list-' + productID).removeClass('d-none');

            // close swatch color
            $('.swatch-list-mobile-tile-' + productID).addClass('d-none');
            $('.open-swatch-list-' + productID).addClass('d-none');
            $('.close-swatch-list-' + productID).removeClass('d-none');
        } else {
            // closing size list
            $sizeContainer.addClass('d-none');
            $('.open-size-list-' + productID).removeClass('d-none');
            $('.close-size-list-' + productID).addClass('d-none');
        }
    });

    const buildSrcSet = (imageSet, prevArrStartIndex, isSwatch) => {
        return imageSet.map((url, idx) => {
            if (isSwatch) {
                return url + ' ' + ((idx + prevArrStartIndex === 0) ? 100 : (idx + prevArrStartIndex) * 200) + 'w';
            } else {
                return url + ' ' + ((idx + prevArrStartIndex) * 200) + 'w';
            }
        }).join(',');
    };

    // request size from plp
    $(document).on('click', '.js-open-requestsize-pdp', function () {
        var redirectUrl = $(this).data('urlredirect');
        window.location.href = redirectUrl;
    });

    $(document).on('keydown', '.js-select-size-tile-radio, .js-select-size-tile-mobile', (e) => {
        if (e.keyCode === 13) {
            e.preventDefault(); // Ensure it is only this code that runs
            $(e.currentTarget).trigger('click');
        }
    });

    $(document).on('click', '.js-select-size-tile-radio, .js-select-size-tile-mobile, .js-select-color-tile', (e) => {
        var $clickedElement = $(e.currentTarget);
        if (!e.currentTarget.classList.contains('disabled')) {
            if (e.currentTarget.classList.contains('js-add-color-variation-analytics')) {
                var newColor = $(e.currentTarget).data('value');
            }
            $.spinner().start();
            let $productContainer = $(e.currentTarget).closest('.product');
            var bigTileRequired = false;
            if ($productContainer.parents('.grid2-central-tile-margin').length > 0) {
                bigTileRequired = true && !window.isMobile;
            }
            if ($clickedElement.hasClass('js-select-size-tile-radio')) {
                var sizeCode = $clickedElement.attr('data-value');
            }
            $.ajax({
                url: $(e.currentTarget).data('select'),
                method: 'GET',
                data: {
                    bigTileRequired: bigTileRequired
                },
                success: function (data) {
                    $.spinner().stop();
                    $('.js-available-size-title', $productContainer).css('color', '#262626');
                    $('.error-select-size', $productContainer).addClass('d-none');
                    var $sizeContainer = $clickedElement.closest('.cc-size-color-modal').find('.cc-select-size-tile');
                    var sizeTemplate = window.isMobile ? 'availableSizesMobileHtml' : 'availableSizesHtml';
                    $sizeContainer.replaceWith($(data.product[sizeTemplate]).filter('.cc-select-size-tile'));
                    $('.js-add-to-wishlist', $productContainer).data('pid', data.product.sku);
                    $('.js-microcolor', $productContainer).addClass('d-none');
                    $('.js-selected-color', $productContainer).addClass('d-none');
                    $('.js-add-to-wishlist-banner-container', $productContainer).replaceWith(data.product.wishlistBannerHtml);
                    if (data.product.hasVerticalVideo && $productContainer.parents('.grid2-central-tile-margin').length === 0) {
                        $('.js-image-container .js-analytics-click-product, .js-image-container .justify-content-center', $productContainer).remove();
                        $('.js-image-container .cc-vertical-video', $productContainer).remove();
                        $('.js-image-container .js-pdp-variant-link', $productContainer).append(data.product.imageVideoTemplateTileHtml);
                        $('.js-image-container .js-pdp-variant-link .js-analytics-click-product', $productContainer).attr('data-pid', $('.js-image-container', $productContainer).data('id'));
                    } else if (data.product.hasHorizontalVideo && $productContainer.parents('.grid2-central-tile-margin').length > 0) {
                        $('.js-image-container .js-analytics-click-product, .js-image-container .justify-content-center', $productContainer).remove();
                        $('.js-image-container .cc-vertical-video, .js-image-container .cc-horizontal-video', $productContainer).remove();
                        $('.js-image-container .js-pdp-variant-link', $productContainer).append(data.product.imageVideoTemplateTileHtml);
                        $('.js-image-container .js-pdp-variant-link .js-analytics-click-product', $productContainer).attr('data-pid', $('.js-image-container', $productContainer).data('id'));
                        $productContainer.removeClass('grid2BigTile');
                    } else if (data.product.horizontalImage.horizontalImageUrl && $productContainer.parents('.grid2-central-tile-margin').length > 0 && !window.isMobile) {
                        if ($('.js-image-container .cc-vertical-video, .js-image-container .cc-horizontal-video', $productContainer).length > 0) {
                            $('.js-image-container .js-analytics-click-product', $productContainer).remove();
                        }
                        $productContainer.removeClass('grid2BigTile');
                        if ($('.js-image-container .js-tile-image', $productContainer).length === 0) {
                            $('.js-image-container .js-pdp-variant-link', $productContainer).append(data.product.imageVideoTemplateTileHtml);
                            $('.js-image-container .js-analytics-click-product', $productContainer).attr('data-pid', $('.js-image-container', $productContainer).data('id'));
                        } else {
                            if ($('.js-image-container .js-analytics-click-product', $productContainer).hasClass('cc-padding-preload-img')) {
                                $('.js-image-container .js-analytics-click-product', $productContainer).removeClass('cc-padding-preload-img');
                                $('.js-image-container .js-analytics-click-product', $productContainer).addClass('cc-padding-preload-img-horizontal');
                            }
                            var $hResizedUrlsFirstSource = (data.product.horizontalImage.horizontalImageUrl[0].resizedUrls).splice(0, 3);
                            var $hResizedUrlsSecondSource = (data.product.horizontalImage.horizontalImageUrl[0].resizedUrls);
                            $('.js-tile-image', $productContainer).siblings('source').eq(0).attr('srcset', buildSrcSet($hResizedUrlsFirstSource, 0));

                            $('.js-tile-image', $productContainer).siblings('source').eq(1).attr('srcset', buildSrcSet($hResizedUrlsSecondSource, 3));

                            $('.js-tile-image', $productContainer).attr('src', data.product.horizontalImage.horizontalImageUrl[0].absURL);
                        }
                    } else if (data.product.images.swatch.length > 0 && !window.isMobile) {
                        if ($('.js-image-container .cc-horizontal-video, .cc-padding-preload-img-horizontal', $productContainer).length > 0) {
                            $productContainer.addClass('grid2BigTile');
                            var horizontalContainer = $('.cc-padding-preload-img-horizontal', $productContainer);
                            horizontalContainer.removeClass('cc-padding-preload-img-horizontal');
                            horizontalContainer.addClass('cc-padding-preload-img');
                        }
                        if ($('.js-image-container .cc-vertical-video, .js-image-container .cc-horizontal-video', $productContainer).length > 0) {
                            $('.js-image-container .js-analytics-click-product', $productContainer).remove();
                        }
                        if ($('.js-image-container .js-tile-image', $productContainer).length === 0) {
                            $('.js-image-container .js-pdp-variant-link', $productContainer).append(data.product.imageVideoTemplateTileHtml);
                            $('.js-image-container .js-analytics-click-product', $productContainer).attr('data-pid', $('.js-image-container', $productContainer).data('id'));
                        } else {
                            var $swatchResizedUrlsFirstSource = (data.product.images.swatch[0].resizedUrls).splice(0, 4);
                            var $swatchResizedUrlsSecondSource = (data.product.images.swatch[0].resizedUrls);
                            $('.js-tile-image', $productContainer).siblings('source').eq(0).attr('srcset', buildSrcSet($swatchResizedUrlsFirstSource, 0, true));

                            $('.js-tile-image', $productContainer).siblings('source').eq(1).attr('srcset', buildSrcSet($swatchResizedUrlsSecondSource, 4, true));

                            $('.js-tile-image', $productContainer).attr('src', data.product.images.swatch[0].absURL);
                        }
                    } else if (data.product.images.large.length > 0) {
                        if ($('.js-image-container .cc-horizontal-video, .cc-padding-preload-img-horizontal', $productContainer).length > 0) {
                            $productContainer.addClass('grid2BigTile');
                            var horizontalContainer = $('.cc-padding-preload-img-horizontal');
                            horizontalContainer.removeClass('cc-padding-preload-img-horizontal');
                            horizontalContainer.addClass('cc-padding-preload-img');
                        }
                        if ($('.js-image-container .cc-vertical-video, .js-image-container .cc-horizontal-video', $productContainer).length > 0) {
                            $('.js-image-container .js-analytics-click-product', $productContainer).remove();
                        }
                        if ($('.js-image-container .js-tile-image', $productContainer).length === 0) {
                            $('.js-image-container .js-pdp-variant-link', $productContainer).append(data.product.imageVideoTemplateTileHtml);
                            $('.js-image-container .js-analytics-click-product', $productContainer).attr('data-pid', $('.js-image-container', $productContainer).data('id'));
                        } else {
                            var $largeResizedUrlsFirstSource = (data.product.images.large[0].resizedUrls).splice(0, 3);
                            var $largeResizedUrlsSecondSource = (data.product.images.large[0].resizedUrls);
                            $('.js-tile-image', $productContainer).siblings('source').eq(0).attr('srcset', buildSrcSet($largeResizedUrlsFirstSource, 0));

                            $('.js-tile-image', $productContainer).siblings('source').eq(1).attr('srcset', buildSrcSet($largeResizedUrlsSecondSource, 3));

                            $('.js-tile-image', $productContainer).attr('src', data.product.images.large[0].absURL);
                        }
                    }
                    $('.js-only-one-left', $productContainer).addClass('d-none');
                    $('.js-open-requestsize-pdp', $productContainer).addClass('d-none');

                    let $size = $('.js-selected-size', $productContainer);
                    $size.text($size.data('resettext'));

                    data.product.variationAttributes[0].values.forEach(function (attrValue) {
                        let $attrValue = $(`.js-select-color-tile[data-value="${attrValue.value}"]`, $productContainer);
                        $attrValue.removeClass('cc-swatch-rectangle-selected cc-size-no-available');

                        if (!attrValue.selectable) {
                            $attrValue.addClass('cc-size-no-available');
                        }
                        if (attrValue.selected) {
                            $attrValue.addClass('cc-swatch-rectangle-selected');
                            $(`.js-microcolor[data-value="${attrValue.value}"]`, $productContainer)
                                .removeClass('d-none')
                                .text(attrValue.microcolor);
                            $(`.js-selected-color[data-value="${attrValue.value}"]`, $productContainer).removeClass('d-none');
                            if (attrValue.pdpUrl) {
                                $('.js-pdp-variant-link', $productContainer).attr('href', attrValue.pdpUrl);
                                if ($('.js-pdp-variant-link', $productContainer).attr('rel')) {
                                    $('.js-pdp-variant-link', $productContainer).attr('rel', attrValue.pdpUrl);
                                }
                            }
                            $('.js-add-to-wishlist', $productContainer).attr('data-color', attrValue.value);
                            $('.js-close-size-color', $productContainer).attr('data-color', attrValue.value);

                            var ariaLabel = $attrValue.attr('data-selected-color');
                            $attrValue.attr('aria-label', ariaLabel);
                        } else {
                            $attrValue.addClass('cc-swatch-rectangle');
                            $attrValue.attr('aria-label', attrValue.microcolor);
                        }
                    });
                    data.product.variationAttributes[1].values.forEach(function (attrValue) {
                        let $attrValue = $(`[data-value="${attrValue.value}"]`, $productContainer);
                        $attrValue.data('select', attrValue.url).prop('disabled', false);

                        $($attrValue).siblings('.js-select-size-tile').removeClass('cc-size-no-available cc-size-element-selected');
                        $($attrValue).siblings('.js-only-one-left').removeClass('cc-size-element-selected');
                        if (!attrValue.selectable) {
                            $attrValue.prop('disabled', true);
                            $($attrValue).siblings('.js-select-size-tile').addClass('cc-size-no-available');
                            $(`.js-open-requestsize-pdp[data-value="${attrValue.value}"]`, $productContainer).removeClass('d-none');
                            $(`.js-open-requestsize-pdp[data-value="${attrValue.value}"]`).prop('disabled', false);
                        }
                        if (attrValue.selected) {
                            $attrValue.addClass('cc-size-element-selected');
                            $('.js-selected-size', $productContainer).text(attrValue.displayValue);
                            $('.cc-size-element').removeClass('cc-size-element-selected');
                            $($attrValue).siblings('.cc-size-element').addClass('cc-size-element-selected');
                        }
                        if (attrValue.isOnlyOneLeft) {
                            $(`.js-only-one-left[data-value="${attrValue.value}"]`, $productContainer).removeClass('d-none');
                        }
                    });

                    var noSizeSelected = data.product.variationAttributes[1].values.every(size => size.selected == false);
                    if (noSizeSelected) {
                        $('.new-analytics', $productContainer).attr({
                            'data-size': '' // reset current size
                        });
                    }

                    // data tags
                    if (data.product.Tag) {
                        $('.js-tag-container span', $productContainer).text(data.product.Tag.toUpperCase());
                        $('.js-tag-container', $productContainer).attr('hidden', false);
                    } else {
                        $('.js-tag-container', $productContainer).attr('hidden', true);
                        $('.js-tag-container span', $productContainer).text('');
                    }

                    // Set the data on the button
                    $('.js-buy-button-plp', $productContainer).data('disabled',
                        (!data.product.readyToOrder || !data.product.available));
                    $('.js-buy-button-plp', $productContainer).attr('data-pid', data.product.id);

                    // Update the price (only if the price was "range")
                    var hasRangePrice = $('.js-product-info', $productContainer).data('has-range-price');
                    if (hasRangePrice && data.product.readyToOrder && data.product.available && data.product.price) {
                        $('.js-price-container', $productContainer).text(data.product.price.sales.formatted);
                        $('.js-price-container', $productContainer).removeClass('d-none');
                    } else {
                        var $priceSelector = $('.cc-price.js-price', $productContainer).length
                            ? $('.cc-price.js-price', $productContainer)
                            : $('.cc-price.js-price');
                        $priceSelector.replaceWith(data.product.price.html);
                    }
                    var skuMaster = data.product.skuMaster;
                    $productContainer.attr('data-skumaster', skuMaster);
                    if (newColor) {
                        $productContainer.find('.js-analytics-click-product-info-' + skuMaster).attr('data-color', newColor);
                    }
       
                    // accessibility: update size and color for selected variant in PLP
                    if ($clickedElement.is('.js-select-color-tile')) {
                        var colorText = $clickedElement.find('.js-microcolor').text();
                        $('#sr-' + skuMaster + '-color').text(colorText);
                        // clear the selected size
                        $('#sr-' + skuMaster + '-size').empty();
                    } else {
                        var sizeText = $clickedElement.attr('data-size');
                        $('#sr-' + skuMaster + '-size').text(sizeText);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            }).done(() => {
                $('body').trigger('wishlist:productVariationChange', [{$element: $productContainer}]);

                // close size selector
                // if (e.currentTarget.classList.contains('js-select-size-tile-mobile')) {
                //     var id = $(e.currentTarget).closest('.cc-size-color-modal').attr('data-productid');
                //     $(`.footer-tile-${id} .cc-mobile-size-list`).trigger('click');
                // }
            });
        }
    });

    // goToPDPLink
    $(document).on('click', '.js-pdp-variant-link', function(e) {
        var $productContainer = $(e.currentTarget).closest('.product');
        var $modalContainer = $productContainer.find('.js-size-color-modal');
        var $boxTile = $productContainer.find('.js-open-size-color');
        if (!$boxTile.length) {
            $boxTile = $productContainer.find('.js-close-size-color');
        }

        var plus = $boxTile.data('plus');
        // close overlay when it's open and tap in img
        if ($modalContainer.hasClass('cc-open')) {
            $modalContainer.removeClass('cc-open');
            $boxTile.removeClass('js-close-size-color').addClass('js-open-size-color');
            $boxTile.parent().find('.js-change-icon').children().attr('xlink:href', plus);
            e.preventDefault();
        }
    });

    // Inspirations Image Animation Desktop
    $(document).on('mouseenter', '.cc-desktop .cc-inspirations .cc-inspirations-items .cc-content-item .cc-item', function (e) {
        var elementId = $(this).data('inspirations');
        $(this).closest('.cc-content-item').siblings().find('.cc-item').removeClass('cc-active');
        $(this).addClass('cc-active');

        $('.cc-inspirations .cc-content-images .cc-content-image').each(function() {
            $(this).removeClass('cc-past');
            if ($(this).data('inspirations') == elementId) {
                $(this).addClass('cc-active');
            } else {
                if ($(this).hasClass('cc-active')) {
                    $(this).removeClass('cc-active');
                    $(this).addClass('cc-past');
                }
            }
        });
    });

    // When the Stories page loads, I need to set the tabindex=-1 to all the elements that do not have any data-category associated
    $('.cc-inspirations .cc-inspirations-elements .cc-inspirations-head .cc-inspirations-filters .cc-filter').each(function() {
        var category = $(this).data('category');
        var items = $('.cc-inspirations-items .cc-content-item[data-category="' + category + '"]');
        var count = items.length;
        if (count === 0) {$(this).addClass('unclickable').attr('tabindex', '-1');}
    });

    // Inspirations Filters
    $(document).on('click keydown focus', '.cc-inspirations .cc-inspirations-head .cc-inspirations-filters .cc-filter', function(e) {
        if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
            if (!$(this).hasClass('cc-active')) {
                var selectedCategory = $(this).data('category');
                var firstChild = false;
    
                $(this).siblings().removeClass('cc-active').attr({
                    'aria-selected': 'false'
                });
                $(this).addClass('cc-active').attr({
                    'aria-selected': 'true'
                });
    
                $('.cc-inspirations .cc-content-images .cc-content-image').each(function () {
                    var element = $(this);
                    if (selectedCategory == '0') {
                        element.show();
                    } else {
                        if (element.data('category') == selectedCategory) {
                            element.show();
                        } else {
                            element.hide();
                        }
                    }
                });
    
                $('.cc-inspirations .cc-inspirations-items .cc-content-item').each(function () {
                    var element = $(this);
                    if (selectedCategory == '0') {
                        element.show();
    
                        if (firstChild == false) {
                            firstChild = true;
                            var elementId = $(this).find('.cc-item').data('inspirations');
    
                            $(this).siblings().find('.cc-item').removeClass('cc-active');
                            $(this).find('.cc-item').addClass('cc-active');
    
                            $('.cc-inspirations .cc-content-images .cc-content-image').each(function() {
                                $(this).removeClass('cc-past');
                                if ($(this).data('inspirations') == elementId) {
                                    $(this).addClass('cc-active');
                                } else {
                                    if ($(this).hasClass('cc-active')) {
                                        $(this).removeClass('cc-active');
                                        $(this).addClass('cc-past');
                                    }
                                }
                            });
                        }
                    } else {
                        if (element.data('category') == selectedCategory) {
                            element.show();
    
                            if (firstChild == false) {
                                firstChild = true;
                                var elementId = $(this).find('.cc-item').data('inspirations');
    
                                $(this).siblings().find('.cc-item').removeClass('cc-active');
                                $(this).find('.cc-item').addClass('cc-active');
    
                                $('.cc-inspirations .cc-content-images .cc-content-image').each(function() {
                                    $(this).removeClass('cc-past');
                                    if ($(this).data('inspirations') == elementId) {
                                        $(this).addClass('cc-active');
                                    } else {
                                        if ($(this).hasClass('cc-active')) {
                                            $(this).removeClass('cc-active');
                                            $(this).addClass('cc-past');
                                        }
                                    }
                                });
                            }
                        } else {
                            element.hide();
                        }
                    }
                });
            }
        }  
    });

    // 23-Module-Mouseover Image Animation Desktop
    $(document).on('mouseenter', '.cc-desktop .cc-pd-mouseover .cc-content-items .cc-content-item .cc-item', function (e) {
        var elementId = $(this).data('item');

        $(this).closest('.cc-pd-mouseover').find('.cc-content-images .cc-content-image').each(function() {
            $(this).removeClass('cc-past');
            if ($(this).data('item') == elementId) {
                $(this).addClass('cc-active');
            } else {
                if ($(this).hasClass('cc-active')) {
                    $(this).removeClass('cc-active');
                    $(this).addClass('cc-past');
                }
            }
        });
    });

    // 23-Module-Mouseover Image Animation Desktop On EXIT
    $(document).on('mouseleave', '.cc-desktop .cc-pd-mouseover .cc-content-items', function (e) {
        var elementId = 0;

        $(this).closest('.cc-pd-mouseover').find('.cc-content-images .cc-content-image').each(function() {
            $(this).removeClass('cc-past');
            if ($(this).data('item') == elementId) {
                $(this).addClass('cc-active');
            } else {
                if ($(this).hasClass('cc-active')) {
                    $(this).removeClass('cc-active');
                    $(this).addClass('cc-past');
                }
            }
        });
    });

    $(document).on('click', '.js-open-registration-modal', function() {
        if ($('body').hasClass('cc-desktop')) {
            $('.js-title-offcanvas').html($('.js-title-offcanvas').data('loginform'));
            var url = $(this).data('action');
            var $loginForm = $('.js-login-form');
            var $resetPwdForm = $('.js-resetpwd-form');
            $.ajax({
                url: url,
                type: 'post',
                success: function (data) {
                    if (data.success) {
                        $('body').addClass('cc-blocked');
                        $loginForm.html(data.renderedTemplate);
                        $(document).find('.cc-loginregistration-overlay').css('content-visibility', 'visible');
                        $('#js-login-registration-modal').fadeIn();
                        accessFocus.focusOnFirstElement('#js-loginregistration-overlay');
                        accessFocus.focuseOnModal('#js-loginregistration-overlay', '.js-open-registration-modal', '#js-login-registration-modal');
                        $('.helpButton, #embeddedMessagingConversationButton').css({
                            display: 'none',
                            visibility: 'hidden'
                        });
                        if ($resetPwdForm.hasClass('cc-hide-form')) {
                            $resetPwdForm.addClass('cc-hide-form');
                        }
                    } else {
                        window.location.href = data.accountPageUrl;
                    }
                },
                error: function () {
                    $('#js-login-registration-modal').fadeOut();
                }
            });
        } else {
            var LoginRegistrationPageUrl = $(this).data('pageurl');
            window.location.href = LoginRegistrationPageUrl;
        }
    });

    $(document).on('submit', 'form.cc-login-form-offCanvas', function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $('form.cc-login-form-offCanvas').trigger('login:submit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                    $('form.login').trigger('login:error', data);
                } else {
                    $('form.login').trigger('login:success', data);
                    location.href = data.redirectUrl;
                }
            },
            error: function (data) {
                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $('form.login').trigger('login:error', data);
                    form.spinner().stop();
                }
            }
        });
        return false;
    });


    $(document).on('click', '.cc-col-title', function(event) {
        var button = $(this).find('button[id^="accordion-"]');
        if (button.length) {
            var ariaExpanded = button.attr('aria-expanded');
            button.attr('aria-expanded', ariaExpanded === 'true' ? 'false' : 'true');
        }
    });

    // reset password offCanvas
    $(document).on('click', '.js-reset-pwd-btn', function() {
        var url = this.dataset.urlreset;
        var $loginForm = $('.js-login-form');
        var $resetPwdForm = $('.js-resetpwd-form');
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'GET',
            success: function (data) {
                $loginForm.addClass('cc-hide-form');
                $resetPwdForm.removeClass('cc-hide-form');
                $('#js-loginregistration-overlay .cc-request-reset-OfCanvas-header').removeClass('cc-hide-form');
                $resetPwdForm.html(data);
                $('.js-title-offcanvas').html($('.js-title-offcanvas').data('resetpwdform'));
                $.spinner().stop();
            }
        });
    });
    // return to login offCanvas
    $(document).on('click', '.js-return-toLogin', function() {
        $('.js-login-form').removeClass('cc-hide-form');
        $('.js-resetpwd-form').addClass('cc-hide-form');
        $('.js-title-offcanvas').html($('.js-title-offcanvas').data('loginform'));
        $('.cc-request-reset-OfCanvas-header').addClass('cc-hide-form');
    });
    $(document).on('click', '.js-goto-login-button', function() {
        if ($('body').hasClass('cc-desktop') || $('body').hasClass('cc-tablet')) {
            $('.js-login-form').removeClass('cc-hide-form');
            $('.js-resetpwd-form').addClass('cc-hide-form');
            $('.js-title-offcanvas').html($('.js-title-offcanvas').data('loginform'));
            $('.cc-request-reset-OfCanvas-header').addClass('cc-hide-form');
        } else {
            $.spinner().start();
            window.location.href = $(this).data('url');
        }
    });

    $(document).on('submit', 'form.cc-resetPwd', function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $('form.cc-resetPwd').trigger('resetpwd:submit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (data.success) {
                    $('form.cc-resetPwd').empty().html(
                        '<div class="cc-response-message">' +
                        '<p class="cc-succes-text-message">' + data.receivedMsgHeading + '</p>' +
                        '<p class="cc-succes-istruction">' + data.receivedMsgBody + '</p></div>'
                    );
                } else {
                }
            },
            error: function (data) {
            }
        });
        return false;
    });

    $(document).on('click', '.js-close-loginRegistration-offCanvas', function() {
        var $loginForm = $('.cc-login-box-container form.cc-login-form-offCanvas');
        var $resetPwdForm = $('.cc-login-box-container form.cc-resetpwd-form-offCanvas');
        if ($loginForm.hasClass('cc-hide-form')) $loginForm.removeClass('cc-hide-form');
        if (!$resetPwdForm.hasClass('cc-hide-form')) $resetPwdForm.addClass('cc-hide-form');
        $('.cc-request-reset-OfCanvas-header').addClass('cc-hide-form');
        $('body').removeClass('cc-blocked');
        $('#js-login-registration-modal').fadeOut();
        setTimeout(function() {
            $('.js-open-registration-modal').focus();
        }, 0);
        $('.helpButton, #embeddedMessagingConversationButton').css({
            display: 'block',
            visibility: 'visible'
        });
        if ($('body').hasClass('veiled')) {
            $('body').removeClass('veiled');
        }
        $('form.cc-login-form-offCanvas').trigger('reset');
        formValidation($('form.cc-login-form-offCanvas'), null);
    });

    $(document).on('click', '.js-loginregistration-closeBy-overlay', function() {
        var $loginForm = $('.cc-login-box-container form.cc-login-form-offCanvas');
        var $resetPwdForm = $('.cc-login-box-container form.cc-resetpwd-form-offCanvas');
        if ($loginForm.hasClass('cc-hide-form')) $loginForm.removeClass('cc-hide-form');
        if (!$resetPwdForm.hasClass('cc-hide-form')) $resetPwdForm.addClass('cc-hide-form');
        $('.cc-request-reset-OfCanvas-header').addClass('cc-hide-form');
        $('body').removeClass('cc-blocked');
        $('#js-login-registration-modal').fadeOut();
        $('.helpButton, #embeddedMessagingConversationButton').css({
            display: 'block',
            visibility: 'visible'
        });
        if ($('body').hasClass('veiled')) {
            $('body').removeClass('veiled');
        }
        $('form.cc-login-form-offCanvas').trigger('reset');
        formValidation($('form.cc-login-form-offCanvas'), null);
    });

    $(document).on('click', '.js-icon-eye, .cc-icon-eye', function (e) {
        e.preventDefault();
        $(this).siblings('input').attr('type') === 'password' ? $(this).siblings('input').attr('type', 'text') : $(this).siblings('input').attr('type', 'password');
        $btn = $(this).find('a.cc-icon-eye-link');
        $btn.attr('aria-pressed', $btn.attr('aria-pressed') === 'true' ? 'false' : 'true');
    });

    if (!('loading' in HTMLImageElement.prototype)) {
        const images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(img => {
            const urls1 = $(img).siblings().eq(0).attr('srcset');
            const urls2 = $(img).siblings().eq(1).attr('srcset');
            const imgUrl = $(img).attr('srcset');
            if (urls1 && urls2) {
                $(img).siblings().eq(0).removeAttr('srcset').attr('data-srcset', urls1);
                $(img).siblings().eq(1).removeAttr('srcset').attr('data-srcset', urls2);
            }
            if (imgUrl) {
                $(img).removeAttr('srcset').attr('data-srcset', imgUrl);
            }
        });
    } else {
        // handle iframes and imgs with no lazysizes library
        document.querySelectorAll('iframe.lazyload').forEach(video => {
            let endPoint = $(video).eq(0).attr('data-video-url');
            if (!endPoint) {
                return;
            }
            if ($(video).hasClass('cloudinary')) {
                video.setAttribute('src', endPoint);
            } else {
                $.ajax({
                    url: endPoint,
                    success: function(data) {
                        video.setAttribute('src', data.videoURL);
                    }
                });
            }
        });
    }

    changeBackground();

    $(document).on('click', '.js-resetPwd-request', function (e) {
        var form = $(this).closest('form');
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $('form.resetPwd').trigger('resetpwd:submit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (data.success) {
                    $('form.cc-resetPwd').empty().html(
                        '<div class="cc-response-message">' +
                        '<p class="cc-succes-text-message">' + data.receivedMsgHeading + '</p>' +
                        '<p class="cc-succes-istruction">' + data.receivedMsgBody + '</p></div>' +
                        '<div class="cc-content-button">' +
                            '<button class="cc-button-primary js-goto-login-button"  data-url="' + data.returnUrl + '" aria-label="' + data.btnText + '">' +
                                data.btnText +
                            '</button>' +
                        '</div>'

                    );
                    $(document).find('.js-request-text').addClass('d-none');
                } else {
                    $('form.cc-resetPwd').find('#forgotPasswordemail').addClass('cc-error');
                    $('form.cc-resetPwd').find('.cc-feedback-message .cc-text-message-error').empty().html(data.loginEmail);
                    $('#forgotPasswordemail').focus();
                }
            },
            error: function (data) {
                $(document).find('.js-request-text').removeClass('d-none');
            }
        });
        return false;
    });

    // apple pay analytics
    $(document).on('click', '.js-analytics-fastCheckout', function() {
        var method = $(this).data('method');
        var accessType = $(this).parents('.js-analytics-position').data('position');
        if ($('.product-detail.cc-pdp').length && !(accessType && accessType.indexOf('pdp') !== 0)) {
            if ($('body:not(.cc-mobile)').length) {
                if ($(this).parents('.js-sticky-add-to-cart').length) {
                    accessType = 'pdp-sticky-bottom';
                } else {
                    accessType = 'pdp';
                }
            } else if ($('.cc-pdp__info--top').length) {
                if ($('.cc-pdp__resume-mobile--fixed').length) {
                    accessType = 'pdp-sticky-top-micro';
                } else {
                    accessType = 'pdp-sticky-top-macro';
                }
            } else {
                accessType = 'pdp-sticky-bottom';
            }
        } else {
            accessType = $(this).parents('.js-analytics-position').data('position');
        }

        $('body').trigger('analytics:dataLayerPushObj', {
            event: 'custom_event',
            eventCategory: 'checkout',
            eventAction: 'fast',
            eventLabel: method,
            accessType: accessType
        });
    });

    $(document).on('click', '.js-button-scroll-down', function (e) {
        var moduleEnd = $(this).closest('.cc-pd').position().top + $(this).closest('.cc-pd').height() - 53;
        $(window).scrollTop(moduleEnd);
    });
    // Analytics search suggestion click link
    $(document).on('click', '.js-analytics-searchLink', function (e) {
        var analiticsSubCategory = $(this).data('analyticscategory');
        var eventAction;
        if ($(this).hasClass('cc-link')) {
            eventAction = $(this).closest('.cc-col-half').find('span a.js-analytics-searchLink').data('analyticscategory');
        } else {
            eventAction = analiticsSubCategory;
        }
        dataLayer.push({
            event: 'internalSearch',
            eventCategory: 'Internal Search',
            eventAction: eventAction,
            eventLabel: analiticsSubCategory
        });
    });
    // Analytics search suggestion did you mean
    $(document).on('click', '.js-analytics-didYouMean', function(e) {
        var label = $(this).data('searchkeyword');
        e.preventDefault();
        $.spinner().start();
        dataLayer.push({
            event: 'internalSearch',
            eventCategory: 'Internal Search',
            eventAction: 'Suggestion',
            eventLabel: label
        });
        window.location.href = $(this).attr('href');
    });

    // 27 - Animated Slide
    if ($('.editmode').length === 0) {
        if ($('.cc-pd-animated-slide').length > 0) {
            window.onload = function() {
                var windowHeight = $(window).height();

                // Set module height
                $('.cc-pd-animated-slide').each(function() {
                    var $moduleWrp = $(this).find('.cc-pd-animated-slide-wrp');
                    var $module = $(this).find('.cc-pd-animated-slide-item');
                    var moduleHeight = $module.outerHeight();
                    $moduleWrp.css('height', moduleHeight + 'px');
                    if ($(this).find('video').length > 0) {
                        $(this).find('video').on('loadstart', function() {
                            var $videoContainer = $moduleWrp.find('.cc-content-video-mobile');
                            var videoConf = $videoContainer.children().data('videoconf');
                            var controlsEnabled = videoConf.indexOf('\\"controls\\":true');
                            if ($videoContainer && controlsEnabled >= 0) {
                                $videoContainer.addClass('video-controls-active');
                            }
                            var moduleHeight = $module.outerHeight();
                            $moduleWrp.css('height', moduleHeight + 'px');
                        });
                    }
                    if ($(this).find('.cc-pd-accordion').length > 0) {
                        $moduleWrp.css('height', 'fit-content');
                    } else {
                        $(window).scroll(function() {
                            moduleHeight = $module.outerHeight();
                            $moduleWrp.css('height', moduleHeight + 'px');
                        });
                    }
                });

                // Animation for attached module on scroll
                if ($('.cc-pd-animated-slide.cc-module-attached').length > 0) {
                    $('.cc-pd-animated-slide.cc-module-attached').each(function() {
                        var $moduleWrp = $(this).find('.cc-pd-animated-slide-wrp');
                        var $module = $(this).find('.cc-pd-animated-slide-item');
                        var moduleHeight = $module.outerHeight();

                        var moduleTop = $moduleWrp.offset().top;
                        var moduleBottom = $moduleWrp.offset().top + moduleHeight;

                        $(window).scroll(function() {
                            var scrollpx = $(window).scrollTop();
                            var bottomMonitor = scrollpx + windowHeight;
                            moduleHeight = $module.outerHeight();
                            moduleTop = $moduleWrp.offset().top;
                            moduleBottom = $moduleWrp.offset().top + moduleHeight;

                            if (moduleHeight >= windowHeight) {
                                if (bottomMonitor >= moduleBottom) {
                                    $module.addClass('cc-module-fixed');
                                } else {
                                    $module.removeClass('cc-module-fixed');
                                }
                            } else {
                                if (scrollpx >= moduleTop) {
                                    $module.addClass('cc-module-fixed-top');
                                } else {
                                    $module.removeClass('cc-module-fixed-top');
                                }
                            }
                        });
                    });
                }

                // Animation for title
                if ($('.cc-pd-animated-slide.cc-animation-title--animated').length > 0) {
                    $('.cc-pd-animated-slide.cc-animation-title--animated').each(function() {
                        var $this = $(this);
                        var $moduleWrp = $(this).find('.cc-pd-animated-slide-wrp');
                        var $module = $(this).find('.cc-pd-animated-slide-item');
                        var moduleHeight = $module.outerHeight();
                        var moduleTop = $moduleWrp.offset().top;
                        var moduleBottom = moduleTop + moduleHeight;
                        var $text = $(this).find('.cc-as-text-wrp > .cc-as-content-text');
                        var textHeight = $text.outerHeight();
                        var scrollpx = $(window).scrollTop();

                        if ($this.hasClass('cc-animation-title--fixed-center')) {
                            $text.addClass('cc-as-content-text--fixed-center');
                            $text.css({ top: windowHeight / 2, position: 'fixed' });
                        } else if ($this.hasClass('cc-animation-title--fade')) {
                            $text.addClass('cc-as-content-text--fixed-center');
                            $text.css({ top: windowHeight / 2, position: 'fixed' });
                            if ((moduleBottom - scrollpx) <= ((windowHeight / 2) + (textHeight / 2))) {
                                $text.addClass('cc-as-content-text--transparent');
                            } else {
                                if ((moduleTop - scrollpx) > ((windowHeight / 2) - (textHeight / 2))) {
                                    $text.addClass('cc-as-content-text--transparent');
                                } else {
                                    $text.removeClass('cc-as-content-text--transparent');
                                }
                            }
                        } else {
                            if ((moduleBottom - scrollpx) <= ((windowHeight / 2) + (textHeight / 2))) {
                                $text.addClass('cc-as-content-text--bottom');
                                $text.removeAttr('style');
                                $text.removeClass('cc-as-content-text--top');
                                $text.removeClass('cc-as-content-text--fixed-center');
                            } else {
                                if ((moduleTop - scrollpx) > ((windowHeight / 2) - (textHeight / 2))) {
                                    $text.addClass('cc-as-content-text--top');
                                    $text.removeAttr('style');
                                    $text.removeClass('cc-as-content-text--fixed-center');
                                    $text.removeClass('cc-as-content-text--bottom');
                                } else {
                                    $text.addClass('cc-as-content-text--fixed-center');
                                    $text.css({ top: windowHeight / 2, position: 'fixed' });
                                    $text.removeClass('cc-as-content-text--top');
                                    $text.removeClass('cc-as-content-text--bottom');
                                }
                            }
                        }

                        $(window).scroll(function() {
                            scrollpx = $(window).scrollTop();
                            moduleHeight = $module.outerHeight();
                            moduleTop = $moduleWrp.offset().top;
                            moduleBottom = moduleTop + moduleHeight;

                            if ($this.hasClass('cc-animation-title--size') && $this.find('.cc-content-title-image').length > 0) {
                                var $titleImage = $this.find('.cc-content-title-image');
                                var difference = moduleBottom - (windowHeight / 2) - (textHeight / 2);
                                var differenceScroll = difference - scrollpx;
                                var res = (1 + (differenceScroll / difference) * 2);
                                if (res < 1) {
                                    res = 1;
                                } else if (res > 3) {
                                    res = 3;
                                }
                                $titleImage.css('transform', 'scale(' + res + ')');
                            }

                            if ($this.hasClass('cc-animation-title--fixed-center')) {
                                $text.addClass('cc-as-content-text--fixed-center');
                                $text.css({ top: windowHeight / 2, position: 'fixed' });
                            } else if ($this.hasClass('cc-animation-title--fade')) {
                                $text.addClass('cc-as-content-text--fixed-center');
                                $text.css({ top: windowHeight / 2, position: 'fixed' });
                                if ((moduleBottom - scrollpx) <= ((windowHeight / 2) + (textHeight / 2))) {
                                    $text.addClass('cc-as-content-text--transparent');
                                } else {
                                    if ((moduleTop - scrollpx) > ((windowHeight / 2) - (textHeight / 2))) {
                                        $text.addClass('cc-as-content-text--transparent');
                                    } else {
                                        $text.removeClass('cc-as-content-text--transparent');
                                    }
                                }
                            } else {
                                if ((moduleBottom - scrollpx) <= ((windowHeight / 2) + (textHeight / 2))) {
                                    $text.addClass('cc-as-content-text--bottom');
                                    $text.removeAttr('style');
                                    $text.removeClass('cc-as-content-text--top');
                                    $text.removeClass('cc-as-content-text--fixed-center');
                                } else {
                                    if ((moduleTop - scrollpx) > ((windowHeight / 2) - (textHeight / 2))) {
                                        $text.addClass('cc-as-content-text--top');
                                        $text.removeAttr('style');
                                        $text.removeClass('cc-as-content-text--fixed-center');
                                        $text.removeClass('cc-as-content-text--bottom');
                                    } else {
                                        $text.addClass('cc-as-content-text--fixed-center');
                                        $text.css({ top: windowHeight / 2, position: 'fixed' });
                                        $text.removeClass('cc-as-content-text--top');
                                        $text.removeClass('cc-as-content-text--bottom');
                                    }
                                }
                            }
                        });
                    });
                }
            };

            // Resize
            $(window).resize(function () {
                var windowHeight = $(window).height();

                // Set module height
                $('.cc-pd-animated-slide').each(function() {
                    var $moduleWrp = $(this).find('.cc-pd-animated-slide-wrp');
                    var $module = $(this).find('.cc-pd-animated-slide-item');
                    var moduleHeight = $module.outerHeight();
                    $moduleWrp.css('height', moduleHeight + 'px');
                    if ($(this).find('video').length > 0) {
                        $(this).find('video').on('loadstart', function() {
                            var $videoContainer = $moduleWrp.find('.cc-content-video-mobile');
                            var videoConf = $videoContainer.children().data('videoconf');
                            var controlsEnabled = videoConf.indexOf('\\"controls\\":true');
                            if ($videoContainer && controlsEnabled >= 0) {
                                $videoContainer.addClass('video-controls-active');
                            }
                            var moduleHeight = $module.outerHeight();
                            $moduleWrp.css('height', moduleHeight + 'px');
                        });
                    }
                    $(window).scroll(function() {
                        moduleHeight = $module.outerHeight();
                        $moduleWrp.css('height', moduleHeight + 'px');
                    });
                });

                // Animation for attached module on scroll
                if ($('.cc-pd-animated-slide.cc-module-attached').length > 0) {
                    $('.cc-pd-animated-slide.cc-module-attached').each(function() {
                        var $moduleWrp = $(this).find('.cc-pd-animated-slide-wrp');
                        var $module = $(this).find('.cc-pd-animated-slide-item');
                        var moduleHeight = $module.outerHeight();

                        var moduleTop = $moduleWrp.offset().top;
                        var moduleBottom = $moduleWrp.offset().top + moduleHeight;

                        $(window).scroll(function() {
                            var scrollpx = $(window).scrollTop();
                            var bottomMonitor = scrollpx + windowHeight;
                            moduleHeight = $module.outerHeight();
                            moduleTop = $moduleWrp.offset().top;
                            moduleBottom = $moduleWrp.offset().top + moduleHeight;

                            if (moduleHeight >= windowHeight) {
                                if (bottomMonitor >= moduleBottom) {
                                    $module.addClass('cc-module-fixed');
                                } else {
                                    $module.removeClass('cc-module-fixed');
                                }
                            } else {
                                if (scrollpx >= moduleTop) {
                                    $module.addClass('cc-module-fixed-top');
                                } else {
                                    $module.removeClass('cc-module-fixed-top');
                                }
                            }
                        });
                    });
                }

                // Animation for title
                if ($('.cc-pd-animated-slide.cc-animation-title--animated').length > 0) {
                    $('.cc-pd-animated-slide.cc-animation-title--animated').each(function() {
                        var $this = $(this);
                        var $moduleWrp = $(this).find('.cc-pd-animated-slide-wrp');
                        var $module = $(this).find('.cc-pd-animated-slide-item');
                        var moduleHeight = $module.outerHeight();
                        var moduleTop = $moduleWrp.offset().top;
                        var moduleBottom = moduleTop + moduleHeight;
                        var $text = $(this).find('.cc-as-text-wrp > .cc-as-content-text');
                        var textHeight = $text.outerHeight();
                        var scrollpx = $(window).scrollTop();

                        if ($this.hasClass('cc-animation-title--fixed-center')) {
                            $text.addClass('cc-as-content-text--fixed-center');
                            $text.css({ top: windowHeight / 2, position: 'fixed' });
                        } else if ($this.hasClass('cc-animation-title--fade')) {
                            $text.addClass('cc-as-content-text--fixed-center');
                            $text.css({ top: windowHeight / 2, position: 'fixed' });
                            if ((moduleBottom - scrollpx) <= ((windowHeight / 2) + (textHeight / 2))) {
                                $text.addClass('cc-as-content-text--transparent');
                            } else {
                                if ((moduleTop - scrollpx) > ((windowHeight / 2) - (textHeight / 2))) {
                                    $text.addClass('cc-as-content-text--transparent');
                                } else {
                                    $text.removeClass('cc-as-content-text--transparent');
                                }
                            }
                        } else {
                            if ((moduleBottom - scrollpx) <= ((windowHeight / 2) + (textHeight / 2))) {
                                $text.addClass('cc-as-content-text--bottom');
                                $text.removeAttr('style');
                                $text.removeClass('cc-as-content-text--top');
                                $text.removeClass('cc-as-content-text--fixed-center');
                            } else {
                                if ((moduleTop - scrollpx) > ((windowHeight / 2) - (textHeight / 2))) {
                                    $text.addClass('cc-as-content-text--top');
                                    $text.removeAttr('style');
                                    $text.removeClass('cc-as-content-text--fixed-center');
                                    $text.removeClass('cc-as-content-text--bottom');
                                } else {
                                    $text.addClass('cc-as-content-text--fixed-center');
                                    $text.css({ top: windowHeight / 2, position: 'fixed' });
                                    $text.removeClass('cc-as-content-text--top');
                                    $text.removeClass('cc-as-content-text--bottom');
                                }
                            }
                        }

                        $(window).scroll(function() {
                            scrollpx = $(window).scrollTop();
                            moduleHeight = $module.outerHeight();
                            moduleTop = $moduleWrp.offset().top;
                            moduleBottom = moduleTop + moduleHeight;

                            if ($this.hasClass('cc-animation-title--size') && $this.find('.cc-content-title-image').length > 0) {
                                var $titleImage = $this.find('.cc-content-title-image');
                                var difference = moduleBottom - (windowHeight / 2) - (textHeight / 2);
                                var differenceScroll = difference - scrollpx;
                                var res = (1 + (differenceScroll / difference) * 2);
                                if (res < 1) {
                                    res = 1;
                                } else if (res > 3) {
                                    res = 3;
                                }
                                $titleImage.css('transform', 'scale(' + res + ')');
                            }

                            if ($this.hasClass('cc-animation-title--fixed-center')) {
                                $text.addClass('cc-as-content-text--fixed-center');
                                $text.css({ top: windowHeight / 2, position: 'fixed' });
                            } else if ($this.hasClass('cc-animation-title--fade')) {
                                $text.addClass('cc-as-content-text--fixed-center');
                                $text.css({ top: windowHeight / 2, position: 'fixed' });
                                if ((moduleBottom - scrollpx) <= ((windowHeight / 2) + (textHeight / 2))) {
                                    $text.addClass('cc-as-content-text--transparent');
                                } else {
                                    if ((moduleTop - scrollpx) > ((windowHeight / 2) - (textHeight / 2))) {
                                        $text.addClass('cc-as-content-text--transparent');
                                    } else {
                                        $text.removeClass('cc-as-content-text--transparent');
                                    }
                                }
                            } else {
                                if ((moduleBottom - scrollpx) <= ((windowHeight / 2) + (textHeight / 2))) {
                                    $text.addClass('cc-as-content-text--bottom');
                                    $text.removeAttr('style');
                                    $text.removeClass('cc-as-content-text--top');
                                    $text.removeClass('cc-as-content-text--fixed-center');
                                } else {
                                    if ((moduleTop - scrollpx) > ((windowHeight / 2) - (textHeight / 2))) {
                                        $text.addClass('cc-as-content-text--top');
                                        $text.removeAttr('style');
                                        $text.removeClass('cc-as-content-text--fixed-center');
                                        $text.removeClass('cc-as-content-text--bottom');
                                    } else {
                                        $text.addClass('cc-as-content-text--fixed-center');
                                        $text.css({ top: windowHeight / 2, position: 'fixed' });
                                        $text.removeClass('cc-as-content-text--top');
                                        $text.removeClass('cc-as-content-text--bottom');
                                    }
                                }
                            }
                        });
                    });
                }
            });
        };
    }

    // Animation text (lateral entry)
    if ($('.cc-animated-text').length > 0) {
        if ($('.cc-animated-text .cc-title').length > 0) {
            $('.cc-animated-text .cc-title').html(function () {
                var chars = $(this).text().split('');
                for (var j = 0; j < chars.length; j) {
                    if (chars[j] === ' ') {
                        chars[j] = '&nbsp;</span></span><span class="cc-single-word"><span class="cc-single-letter cc-sl-' + ++j + '">';
                    } else {
                        chars[j] = chars[j] + '</span><span class="cc-single-letter cc-sl-' + ++j + '">';
                    }
                }
                return '<span class="cc-single-word"><span class="cc-single-letter cc-sl-0">' + chars.join('') + '</span></span>';
            });
        }
    }

    // 30 Relatives Slider and 39 Ghost Carousel
    {
        const cleanClonedSlideAnalytics = function(selector) {
            $(selector).on('init', function (event, slick, direction) {
                $(this).find('.slick-slide.slick-cloned .new-analytics.js-analytics-impressions-product-not-impressed').removeClass('js-analytics-impressions-product-not-impressed');
            });
        }

        const initializeSlider = function(selector) {
            $(selector).each(function () {
                var slidesContainer = $(this);
                var isGhostCarousel = $(this).find('.cc-ghostCarousel-item').length > 0;

                // remove empty childrens
                $(this).children(':empty').remove();

                // hide ghost carousel if has less than 3 child elements
                if (isGhostCarousel && $(this).children().length < 3) {
                    $(this).closest('.cc-pd-ghostCarousel').addClass('d-none');
                }

                slidesContainer.slick({
                    infinite: true,
                    autoplay: false,
                    focusOnSelect: false,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: 4,
                    variableWidth: false,
                    dots: false,
                    arrow: true,
                    prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                    nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>',
                    responsive: [
                        {
                            breakpoint: 1199.98,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 767.98,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 599.98,
                            settings: {
                                slidesToShow: 1,
                                centerMode: isGhostCarousel,
                                centerPadding: isGhostCarousel ? '30px' : '0px'
                            }
                        }
                    ]
                });
                const iframe = document.querySelectorAll('.slick-slide.slick-cloned iframe.lazyload');
                iframe.forEach(video => {
                    let endPoint = $(video).eq(0).attr('data-video-url');
                    if (!endPoint) {
                        return;
                    }
                    if ($(video).hasClass('cloudinary')) {
                        video.setAttribute('src', endPoint);
                    } else {
                        $.ajax({
                            url: endPoint,
                            success: function(data) {
                                video.setAttribute('src', data.videoURL);
                            }
                        });
                    }
                });
            });

            $('.cc-slider-prev').attr('aria-label', window.commonAria.prevSlideProducts.label);
            $('.cc-slider-next').attr('aria-label', window.commonAria.nextSlideProducts.label);
        }

        const updatePrices = function() {
            var productIds = [];
            
            $('.cc-pd-relatives-item .product').each(function(){
                let $product = $(this);
                let pid = $product.attr('data-pid');
                let priceAlreayUpdated = $('.cc-price.js-price', $product).is('[data-price-updated]');
                if (productIds.indexOf(pid) == -1 && ! priceAlreayUpdated) {
                    productIds.push(pid);
                }
            });

            if (productIds.length) {
                $(document).trigger('product:updatePrices', productIds);
            }
        }

        $(document).on('click', '.js-relatives-group-switch', function(event) {
            let creative = $(this).closest('.cc-pd-relatives-groups').attr('data-creative');
            let moduleID = $(this).closest('.cc-pd-relatives-groups').attr('data-id');
            let groupID = $(this).attr('data-groupid');

            let $containerModule = $(this).closest('.cc-pd-relatives-groups');
            let $existingGroup = $(`[defaultgroupid="${groupID}"]:not(:empty)`, $containerModule);

            if ($existingGroup.length) {
                $('.experience-relativesGroups > div', $containerModule).addClass('d-none');
                $existingGroup.removeClass('d-none');

                // update active group CTA
                $(this).addClass('cc-active').siblings().removeClass('cc-active');
            } else {
                let querystring = $('div.page').attr('data-querystring');
                let cid = new URLSearchParams(querystring).get('cid') || $('.storepage').attr('id');
                let $genderPage = $(this).parents('#mainContentContainer[data-page-id]');
                if ($genderPage.length) {
                    var isGenderPage = true;
                    cid = $genderPage.attr('data-page-id');
                }
                $.spinner().start();
                $.ajax({
                    url: $(this).attr('data-url'),
                    type: 'post',
                    data: {
                        cid,
                        _creative: creative,
                        _groupID: groupID
                    },
                    success: function (data) {
                        let $html = $(data).filter(isGenderPage ? 'div.gender-page' :'div.page')
                            .find(`.cc-pd-relatives-groups[data-id=${moduleID}] .experience-relativesGroups > div:not(:empty)`);

                        $('.experience-relativesGroups', $containerModule).append($html);
                        cleanClonedSlideAnalytics('.cc-pd-relatives .cc-slider');
                        initializeSlider($(`[defaultgroupid="${groupID}"] .cc-pd-relatives .cc-slider`, $containerModule));

                        $('.experience-relativesGroups > div', $containerModule).addClass('d-none');
                        $(`[defaultgroupid="${groupID}"]:not(:empty)`, $containerModule).removeClass('d-none');

                        // update active group CTA
                        $(event.target).addClass('cc-active').siblings().removeClass('cc-active');
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }

            $('body').trigger('analytics:dataLayerPushObj', {
                event: 'custom_event',
                eventCategory: 'relatives switch',
                eventAction: groupID
            });
        });

        const initializeRelativesSlider = function(parent='') {
            if ($(`${parent} .cc-slider .slick-slide`).length === 0) {
                cleanClonedSlideAnalytics(`${parent} .cc-slider`);
                initializeSlider(`${parent} .cc-slider`);
                // Adding tabindex -1 to all images inside the carousel.
                // This is needed because "slick" method automatically set the tabindex 0 but this causes accessibility issues
                $(`${parent} .cc-slider .js-pdp-variant-link.cc-standard-image`).attr('tabindex', -1);
            }
        }

        if ($('.cc-pd-relatives').length > 0) {
            initializeRelativesSlider('.cc-pd-relatives');
            updatePrices();
        }

        if ($('.cc-pd-ghostCarousel').length > 0) {
            initializeRelativesSlider('.cc-pd-ghostCarousel');
        }

        $(document).on('experience:init-30-relatives', function(_, parent){
            initializeRelativesSlider(`${parent} .cc-pd-relatives`);
            updatePrices();
        });
    }

    if ($('.cc-pd-slider-double-same.js-sliderContainer .cc-slider').length > 0) {
       
        if ($('.cc-pd-slider-double-same.js-sliderContainer .cc-slider .slick-slide').length === 0) {
            $('.cc-pd-slider-double-same.js-sliderContainer .cc-slider').each(function () {
                var slidesContainer = $(this);

                slidesContainer.slick({
                    infinite: true,
                    autoplay: false,
                    focusOnSelect: true,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    variableWidth: false,
                    dots: false,
                    arrow: true,
                    prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                    nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>'
                });
            });
        }
    };

    // 31 Shop the image
    if ($(document).find('.cc-pd-shop-the-image').length > 0) {
        // handle open in new tab cta shop the image, replace
        var hrefsToReplace = $(document).find('a[href^="shop-the-image"]');
        hrefsToReplace.each(function (index, elem) {
            var dataTarget = elem.attributes.href.value;
            var classes = elem.attributes.class ? elem.attributes.class.value : null;
            var value = elem.innerHTML;
            var ariaLabel = $('input[class="btn-aria-label-open-mobal"]').val();
            var button = document.createElement('button');
            $(button).attr('data-target', dataTarget);
            $(button).attr('class', classes);
            $(button).attr('id', 'btn-' + dataTarget);
            $(button).attr('aria-label', ariaLabel);
            button.innerHTML = value;
            $(elem.parentNode).append(button);
            $(elem).remove();
        });
        $(document).on('click', 'button[data-target^="shop-the-image"]', function(e) {
            e.preventDefault();
            var target = `#${$(this).attr('data-target')}`;
            if ($(target).length) {
                var m = new Modal(target, {
                    onShow: ()=> {
                        $(document).trigger('shop-the-image:modal-open');
                        $('body:not(.cc-desktop)').addClass('cc-blocked');
                    },
                    onClose: () => $('body:not(.cc-desktop)').removeClass('cc-blocked')
                });
                m.open();

                $('.js-shop-the-image-close').one('click', function() {
                    m.close();
                });
                $('body').on('product:afterAddToCart', function () {
                    m.close();
                });
            }
        });

        // refresh product prices
        var productIds = [];
        $('.cc-pd-shop-the-image .product').each(function(){
            let $product = $(this);
            let pid = $product.attr('data-pid');
            let priceAlreayUpdated = $('.cc-price.js-price', $product).is('[data-price-updated]');
            if (productIds.indexOf(pid) == -1 && ! priceAlreayUpdated) {
                productIds.push(pid);
            }
        });

        if (productIds.length) {
            $(document).trigger('product:updatePrices', productIds);
        }
    }

    // 32 Accordion
    if ($(document).find('.cc-pd-accordion').length > 0) {
        $('.cc-pd a.cc-cta, .cc-pd a.cc-button').each(function() {
            if ($(this).attr('href').indexOf('accordion') !== -1) {
                $(this).attr('data-toggle', 'collapse');
                $(this).addClass('collapsed');
                $(this).attr('role', 'button');
                $(this).attr('aria-expanded', 'false');
                $(this).attr('aria-controls', $(this).attr('href'));
                $(this).attr('href', '#' + $(this).attr('href'));
                var ctaText = $(this).text();
                var arrowImg = $(document).find('.cc-pd-accordion')[0].dataset.arrow;
                $(this).html(ctaText + '<svg class="cc-icon" aria-hidden="true" focusable="false"><use xlink:href="' + arrowImg + '"></use></svg>');
            }
        });
    }

    // 34 Page Anchor
    if ($(document).find('.cc-pd-page-anchor').length > 0) {
        $(document).on('click', '.cc-pd-page-anchor .js-page-anchor-menu', function (e) {
            e.preventDefault();
            $(this).closest('.cc-content-buttons').toggleClass('cc-open');
        });

        var headerHeight = $('.cc-header').outerHeight();
        var anchorHeadHeight = $('.cc-pd-page-anchor .cc-page-anchor-head').outerHeight();
        var anchorOffset = headerHeight + anchorHeadHeight;

        $('.cc-pd-page-anchor .cc-page-anchor-head').addClass('cc-page-anchor-head-fixed');
        $('.cc-pd-page-anchor .cc-page-anchor-head').css('top', headerHeight + 'px');
        // $('.cc-pd-page-anchor .cc-anchor-point').css('top', '-' + anchorOffset + 'px');

        $(document).on('headerSticky:true', function() {
            headerHeight = $('.cc-header').outerHeight();
            anchorOffset = headerHeight + anchorHeadHeight;
            $('.cc-pd-page-anchor .cc-page-anchor-head').css('top', headerHeight + 'px');
            // $('.cc-pd-page-anchor .cc-anchor-point').css('top', '-' + anchorOffset + 'px');
        });
        $(document).on('headerSticky:false', function() {
            headerHeight = $('.cc-header').outerHeight();
            anchorOffset = headerHeight + anchorHeadHeight;
            $('.cc-pd-page-anchor .cc-page-anchor-head').css('top', headerHeight + 'px');
            // $('.cc-pd-page-anchor .cc-anchor-point').css('top', '-86px');
        });

        // close anchor selection dropdown after selecting one
        $(document).on('click', '.cc-page-anchor-head-item', function() {
            if (window.isDesktop) return;
            $(this).parents('.cc-content-buttons').removeClass('cc-open');
        });

        // scroll to the top of the page
        $(document).on('click', '.cc-page-anchor-gototop', function() {
            $(document).scrollTop(0);
        });

        // adjust anchor positioning
        var headerBannerHeight = $('.js-header-banner').innerHeight() || 0;
        if (headerBannerHeight) {
            $('.cc-anchor-point').each(function() {
                var currentValue = parseInt($(this).css('top'));
                $(this).css('top', currentValue - headerBannerHeight + 'px');
            });
        }

        var pageAnchorHeight = $('.cc-page-anchor-main-wrp').height();
        var $progressBar = $('.cc-page-anchor-head .cc-progressbar-active');
        var header = $('.js-header')[0];
        var anchorItems = $('.cc-page-anchor-main-wrp > .cc-page-anchor-main-item').toArray();
        var headerHeightDiff;
        if (window.isDesktop) headerHeightDiff = 141 - 55;
        else if (window.isTablet) headerHeightDiff = 141 - 87;
        else headerHeightDiff = 83 - 55;

        $(document).on('scroll', _throttle(function(e) {
            // calculate progress
            var currentScroll = $(document).scrollTop();
            var progress = currentScroll / (pageAnchorHeight + headerHeightDiff + headerBannerHeight) * 100;
            $progressBar.css('width', progress + '%');

            // activate current section
            var target = header.offsetHeight + anchorHeadHeight;
            for (var item of anchorItems) {
                var pos = item.getBoundingClientRect();
                if (pos.top <= target && pos.bottom > target) {
                    $('.cc-page-anchor-head-item > .cc-item-button.active').removeClass('active');
                    var id = $(item).find('.cc-anchor-point').attr('id');
                    $('.cc-item-button[href$=' + id + ']').addClass('active');
                    break;
                }
            }
        }, 150));
    }

    // 38 Newsletter overlay
    var hrefsToReplaceNewsletter = $(document).find('a[href^="overlay-newsletter"]');
    hrefsToReplaceNewsletter.each(function (index, elem) {
        var dataTarget = elem.attributes.href.value;
        var classes = elem.attributes.class ? elem.attributes.class.value : '';
        var dataCsCverrideId = elem.attributes['data-cs-override-id'] ? elem.attributes['data-cs-override-id'].value : null;
        var value = elem.innerHTML;
        var ariaLabel = $('input[name="aria-label-nl-openmodal"]').val();
        var dataAnalyticsLabel = elem.attributes['data-analyticslabel'] ? elem.attributes['data-analyticslabel'].value : null;
        var button = document.createElement('button');
        $(button).attr('data-target', dataTarget);
        $(button).attr('class', classes);
        $(button).attr('aria-label', ariaLabel);
        $(button).attr('data-cs-override-id', dataCsCverrideId);
        $(button).attr('data-analyticslabel', dataAnalyticsLabel);
        button.innerHTML = value;
        $(elem.parentNode).append(button);
        $(elem).remove();
    });

    $(document).on('click', 'button[data-target^="overlay-newsletter"]:not(.js-footer-newsletter-button)', function(e) {
        e.preventDefault();
        var target = $(this).attr('data-target');
        var analyticsLabel = $(this).data('analyticslabel') || 'banner_editoriale';
        // var source = $(this).attr('data-source');
        $(document).trigger('overlaynewsletter:showmodal', {
            target: target,
            source: analyticsLabel
        });
    });
    // Select newsletter preferences click event
    $(document).on('click', '.js-newsletter .cc-newsletter-form-preferences .cc-checkbox', function(e) {
        var $preferences = $(this).closest('.cc-newsletter-form-preferences');
        var countCheckedPreferences = $('.cc-checkbox:checked', $preferences).length;
        var privacyContainer = $preferences.siblings('.js-newsletter-privacy');
        var isFirstCheckedPreferences = countCheckedPreferences === 1 && privacyContainer.hasClass('d-none');
        var $privacyField = privacyContainer.find('.js-privacyShopping[value="true"]');
        if (countCheckedPreferences > 0) {
            privacyContainer.removeClass('d-none');
        } else if (!$privacyField.length || !$privacyField.is(':checked')) { // preventing hiding consent section if customer select consent
            privacyContainer.addClass('d-none');
        }
        if (isFirstCheckedPreferences) {
            scrollAnimate($preferences.siblings('.js-newsletter-privacy'), { scrollableParent: $preferences.closest('.cc-overlay-info') });
        }
    });

    // Accessibility on new Newsletter Modal Instance ID: 2194494626
    $(document).ready(function() {
        if ($(document).find('.js-form-overlay-newsletter button[role="combobox"]').length > 0) {
            var buttonElement = $('.js-form-overlay-newsletter button[role="combobox"]')[0];
            var selectElement = $('.js-form-overlay-newsletter select')[0];
            buttonElement.setAttribute('aria-controls', selectElement.getAttribute("id"));
        }
    });

    $(document).on('click', '.js-form-overlay-newsletter-step1 button[type="submit"]', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $form = $(this.form);
        var $modal = $form.closest('.cc-overlay-info');
        var url = $form.attr('data-action');
        var modalSource = $(this).closest('.cc-pd-overlay-newsletter.cc-open').data('analyticslabel');
        const readyToSubmit = $.Deferred();

        function doSubmit() {
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: $form.serialize(),
                beforeSend: function() {
                    $.spinner().start();
                },
                complete: function() {
                    $.spinner().stop();
                },
                success: function(data) {
                    if (data.success) {
                        // Switch to step 2
                        $('.js-overlay-title-top--step-1', $modal).addClass('d-none');
                        $('.js-overlay-title-top--step-2', $modal).removeClass('d-none');
                        $('.cc-overlay-info__titles--step1', $modal).addClass('d-none');
                        $('.cc-overlay-form--step1', $modal).addClass('d-none');
                        $('.cc-overlay-info__titles--step2', $modal).removeClass('d-none');
                        $('.cc-overlay-form--step2', $modal).removeClass('d-none');
                        $('.js-nwl-email-step2', $modal).val(data.email);

                        $(document).trigger('analytics:newsletter', { eventAction: 'submit_ok', eventLabel: modalSource });
                        $(document).trigger('analytics:newsletter', { eventAction: 'step2', eventLabel: modalSource });
                    } else {
                        if (data.isCustomer) {
                            $('.js-overlaynewsletter-customer-exist', $form).removeClass('cc-invisible');
                        } else {
                            $('.js-overlaynewsletter-technical-error', $form).removeClass('cc-invisible');
                            $(document).trigger('analytics:newsletter', { eventAction: 'submit_fail', eventLabel: modalSource });
                        }
                    }
                },
                error: function() {
                    $('.js-overlaynewsletter-technical-error', $form).removeClass('cc-invisible');
                    $(document).trigger('analytics:newsletter', { eventAction: 'submit_fail', eventLabel: modalSource });
                }
            });
        }

        // CAPTCHA handling based on country
        if ($('.js-tencent-captcha-container').length) {
            const $tencentCaptcha = $('.js-tencent-captcha-container', $form);
            TencentCaptcha.initialize($tencentCaptcha, readyToSubmit);
            readyToSubmit.done(doSubmit);
        } else {
            GrecaptchaV3.initialize(doSubmit);
        }

        return false;
    });

    $(document).on('click', '.js-form-overlay-newsletter-step2 button[type="submit"]', function(e) {
        var $form = $(this.form);
        var $modal = $form.closest('.cc-overlay-info');
        var url = $form.attr('data-action');
        var modalSource = $(this).closest('.cc-pd-overlay-newsletter.cc-open').data('analyticslabel');
        var randomId = $form.attr('data-id');

        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: $form.serialize(),
            beforeSend: function() {
                $.spinner().start();
            },
            complete: function() {
                $.spinner().stop();
            },
            success: function(data) {
                if (data.success) {
                    // switch to thank you page
                    $('.cc-overlay-info__titles--step2', $modal).addClass('d-none');
                    $('.cc-overlay-form--step2', $modal).addClass('d-none');
                    $('.cc-overlay-typ', $modal).removeClass('d-none');
                    $(document).trigger('analytics:newsletter', { eventAction: 'submit_ok_step2', eventLabel: modalSource });
                    if (data.filledData) {
                        var filledData = data.filledData;
                        $(document).trigger('analytics:newsletter',
                            { eventAction: 'save_preferences',
                                eventLabel: `${filledData.name}|${filledData.surname}|${filledData.consent}|${filledData.interest}`,
                                other: filledData.interestlist.replaceAll(';', '|')
                            }
                        );
                    }

                    $('.cc-pd-overlay-newsletter.cc-open .js-pd-overlay-close').on('click', function() {
                        if (!$('.cc-overlay-typ', $modal).hasClass('d-none')) {
                            $('.cc-pd-overlay-newsletter.cc-open').addClass('prevent-analytics-close');
                            $(document).trigger('analytics:newsletter', { eventAction: 'confirmation_close', eventLabel: modalSource });
                            $('.cc-overlay-info__titles--step1', $modal).removeClass('d-none');
                            $('.cc-overlay-form--step1', $modal).removeClass('d-none');
                            $('.cc-overlay-typ', $modal).addClass('d-none');
                        }
                    });
                } else {
                    $('.js-overlaynewsletter-technical-error', $form).removeClass('cc-invisible');
                    $(document).trigger('analytics:newsletter', { eventAction: 'submit_fail', eventLabel: modalSource });
                }
            },
            error: function() {
                $('.js-overlaynewsletter-technical-error', $form).removeClass('cc-invisible');
                $(document).trigger('analytics:newsletter', { eventAction: 'submit_fail', eventLabel: modalSource });
            }
        });
        return false;
    });

    $(document).on('click', '.js-form-overlay-newsletter-full button[type="submit"]', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $form = $(this).closest('.js-form-overlay-newsletter');
        var $modal = $form.closest('.cc-overlay-info');
        var modalSource = $(this).closest('.cc-pd-overlay-newsletter.cc-open').data('analyticslabel');
        var chatAlreadyHidden = $form.closest('.cc-pd-overlay-newsletter').data('chatAlreadyHidden');
        var simpleType = $modal.closest('.js-newsletter').attr('data-type') === 'simple';

        if ($form.attr('data-target')) {
            $('.cc-pd-overlay-newsletter.cc-open').addClass('prevent-analytics-close');
            $(document).trigger('overlaynewsletter:showmodal', {
                target: $form.attr('data-target'),
                source: modalSource,
                email: $('input[type="email"]', $form).val(),
                chatAlreadyHidden: chatAlreadyHidden
            });
            return false;
        }

        var url = $form.attr('data-action');
        var randomId = $form.attr('data-id');
        const readyToSubmit = $.Deferred();

        function doSubmit() {
            $.ajax({
                url: url,
                method: 'post',
                dataType: 'json',
                data: $form.serialize(),
                beforeSend: function () {
                    $.spinner().start();
                },
                complete: function () {
                    $.spinner().stop();
                },
                success: function (data) {
                    if (data.success) {
                        if (simpleType) {
                            $(document).trigger('overlaynewsletter:close', {
                                submit: true
                            });
                            $('.js-popUp-newsletter-upload').html(data.popUp);
                            var successPopup = new Modal('.cc-overlay-success-popup[data-id="' + randomId + '"]', {
                                onClose: liveChatEnable
                            });
                            successPopup.open();
                            $('.js-close-popup-overlay', successPopup.modal).one('click', function () {
                                successPopup.close();
                                $(document).trigger('analytics:newsletter', {
                                    eventAction: 'confirmation_close',
                                    eventLabel: modalSource
                                });
                            });
                        } else {
                            // switch to thank you page
                            $('.cc-overlay-form', $modal).addClass('d-none');
                            $('.cc-overlay-info__titles', $modal).addClass('d-none');
                            $('.cc-overlay-typ', $modal).removeClass('d-none');

                            $('.cc-pd-overlay-newsletter.cc-open .js-pd-overlay-close').on('click', function () {
                                if (!$('.cc-overlay-typ', $modal).hasClass('d-none')) {
                                    $('.cc-pd-overlay-newsletter.cc-open').addClass('prevent-analytics-close');
                                    $(document).trigger('analytics:newsletter', {
                                        eventAction: 'confirmation_close',
                                        eventLabel: modalSource
                                    });
                                    $('.cc-overlay-info__titles', $modal).removeClass('d-none');
                                    $('.cc-overlay-form', $modal).removeClass('d-none');
                                    $('.cc-overlay-typ', $modal).addClass('d-none');
                                }
                            });
                        }

                        $(document).trigger('analytics:newsletter', {
                            eventAction: 'submit_ok',
                            eventLabel: modalSource
                        });

                        if (data.filledData) {
                            var filledData = data.filledData;
                            $(document).trigger('analytics:newsletter', {
                                eventAction: 'save_preferences',
                                eventLabel: `${filledData.name}|${filledData.surname}|${filledData.consent}|${filledData.interest}`,
                                other: filledData.interestlist.replaceAll(';', '|')
                            });
                        }
                    } else {
                        if (data.isCustomer) {
                            $('.js-overlaynewsletter-customer-exist', $form).removeClass('cc-invisible');
                        } else {
                            $('.js-overlaynewsletter-technical-error', $form).removeClass('cc-invisible');
                            $(document).trigger('analytics:newsletter', {
                                eventAction: 'submit_fail',
                                eventLabel: modalSource
                            });
                        }
                    }
                },
                error: function (data) {
                    $('.js-overlaynewsletter-technical-error', $form).removeClass('cc-invisible');
                    $(document).trigger('analytics:newsletter', {
                        eventAction: 'submit_fail',
                        eventLabel: modalSource
                    });
                }
            });
        }

        if (simpleType) {
            readyToSubmit.resolve();
        } else {
            if ($('.js-tencent-captcha-container').length) {
                var $tencentCaptcha = $('.js-tencent-captcha-container', $form);
                TencentCaptcha.initialize($tencentCaptcha, readyToSubmit);
            } else {
                GrecaptchaV3.initialize(doSubmit);
                return false;
            }
        }

        readyToSubmit.done(doSubmit);
        return false;
    });

    $(document).on('click', '.js-analytics-nwl-registration', function(e) {
        var modalSource = $(this).closest('.cc-pd-overlay-newsletter.cc-open').data('analyticslabel');
        $(document).trigger('analytics:newsletter', { eventAction: 'go_to_registration', eventLabel: modalSource });
    });

    $(document).on('click', '.js-analytics-nwl-notnow', function(e) {
        var modalSource = $(this).closest('.cc-pd-overlay-newsletter.cc-open').data('analyticslabel');
        $(document).trigger('analytics:newsletter', { eventAction: 'not_now', eventLabel: modalSource });

        $(document).trigger('overlaynewsletter:close', {
            submit: true
        });
    });

    $(document).on('overlaynewsletter:showmodal', function(e, data) {
        var modal;
        if (!data) {
            // event dispatched from vanilla custom event
            data = e.originalEvent.detail;
        }

        var modalTarget = data.target;
        var source = data.source;
        var email = data.email;

        CSRFUtil.refreshToken();

        // close current modal (usefull for mini popup)
        $('.cc-pd-overlay-newsletter.cc-open .js-pd-overlay-close').trigger('click', {submit: true});

        var $target = $(`.${modalTarget}`);
        if ($target.length) {
            $target.data('analyticslabel', source);
            var autoRefreshID;
            modal = new Modal($target, {
                onShow: () => {
                    // auto refresh CSRF token every 45 minutes
                    autoRefreshID = CSRFUtil.startAutoRefresh(45);
                    if (data.chatAlreadyHidden !== undefined) {
                        var chatAlreadyHidden = chatAlreadyHidden;
                    } else {
                        var chatAlreadyHidden = $('.helpButton, #embeddedMessagingConversationButton').eq(0).is(':hidden');
                    }
                    modal.custom.chatAlreadyHidden = chatAlreadyHidden;
                    modal.modal.data('chatAlreadyHidden', chatAlreadyHidden);
                    if (! chatAlreadyHidden) liveChatDisable();
                },
                onClose: () => {
                    CSRFUtil.stopAutoRefresh(autoRefreshID);
                    if (! modal.custom.submit && ! modal.custom.chatAlreadyHidden) {
                        liveChatEnable();
                        // remove event listeners
                        $target.off();
                    }
                }
            });

            var $grecaptcha = $('.js-captcha-form.lazyloading', $target);
            if ($grecaptcha.length) {
                document.body.dispatchEvent(new CustomEvent('grecaptcha-load', {detail: $grecaptcha}));
            }

            if (email) {
                $('input[type="email"]', $target).val(email);
            }
            
            modal.open();

            
            $target.on('click', '.js-pd-overlay-close', function(e, data) {
                e.stopImmediatePropagation();
                var object = $('.cc-pd-overlay-newsletter.cc-open');
                if (data && data.submit) {
                    modal.custom.submit = true;
                }
                modal.close();
                if (!object.hasClass('prevent-analytics-close')) {
                    var label = object.data('analyticslabel');
                    $(document).trigger('analytics:newsletter', { eventAction: 'dismiss', eventLabel: label });
                } else {
                    object.removeClass('prevent-analytics-close');
                }
            });

            $target.on('click', '.js-overlaynewsletter-customer-exist .cc-link', function(e) {
                e.stopImmediatePropagation();
                $('.js-pd-overlay-close', $target).trigger('click');
                if (window.isDesktop) {
                    scrollAnimate(0, {duration: 200});
                    $('.js-open-registration-modal').eq(0).trigger('click');
                } else {
                    document.location = $(this).closest('#js-take-to-login').data('url');
                }
            });
            // analytics modal open
            var action = $target.hasClass('cc-pd-overlay-newsletter--small') ? 'mini_popup_open' : 'start';
            $(document).trigger('analytics:newsletter', { eventAction: action, eventLabel: source });
        }
    });

    // utilizzato dalla submit della form per dismettere la modale
    $(document).on('overlaynewsletter:close', function(e, data) {
        // analytics modal close
        if (data && data.submit) {
            $('.cc-pd-overlay-newsletter.cc-open').addClass('prevent-analytics-close');
        }
        $('.cc-pd-overlay-newsletter.cc-open .js-pd-overlay-close').trigger('click', data);
    });

    // set cookies
    if ($('.cc-pd-sticky-banner').length > 0) {
        $('.cc-pd-sticky-banner').each(function() {
            var cookieName = $(this).data('cookiename');
            var cookie = getCookie(cookieName);
            if (!cookie) {
                $(this).removeClass('d-none');
                var nameBanner;
                var bannerHeigth = $(document).find('.js-banner-cookie').height() + 3;
                var tagStyle = '<style id=button-banner-style> .embeddedServiceHelpButton .helpButton{bottom:' + bannerHeigth + 'px!important}</style>';
                $('body').append(tagStyle);
                if ($('.storepage').length > 0) {
                    nameBanner = $('.storepage').attr('id');
                } else {
                    nameBanner = $(document).find('#searchList').val();
                }
                if ($('body').hasClass('cc-mobile') && ($(document).find('.sticky-bar-mobile').length > 0) && !$(this).hasClass('custom-margin')) {
                    var filterButtonHeigt = $(document).find('.sticky-bar-mobile').height() + 'px';
                    $(this).css('bottom', filterButtonHeigt);
                }

                dataLayer.push({
                    event: 'promoView',
                    ecommerce: {
                        promoView: {
                            promotions: [{
                                id: $(this).data('id'),
                                name: nameBanner,
                                creative: $(this).data('creative'),
                                position: 0
                            }]
                        }
                    }
                });
            }
        });
    }
    $(document).on('click', '.js-close-stickybanner', function () {
        var cookieName = $(this).closest('.js-banner-cookie').data('cookiename');
        var cookieExpire = $(this).closest('.js-banner-cookie').data('savingtime');
        setCookie(cookieName, true, cookieExpire);
        $(this).closest('.js-banner-cookie').addClass('d-none');
        $(document).find('#button-banner-style').remove();
        var bannerId = $(this).closest('.cc-pd-sticky-banner').data('id');
        dataLayer.push({
            event: 'custom_event',
            eventCategory: 'Ecommerce',
            eventAction: 'Promotion Close',
            eventLabel: bannerId
        });
    });

    if ($('.js-button-scroll-down').length) {
        if (isSafari()) {
            $('.js-button-scroll-down, .cc-pd-hero-xl-full .cc-scroll-down.cc-valign-bottom').addClass('cc-safari');
        }
    }

    // whatsapp integration logic
    function whatsappIntegration (){
        var $whatsApp = $('.js-whatsapp-integration');
        if ($whatsApp.length) {
            var url = $whatsApp.data('url');
            if (url) {
                $.ajax({
                    url: url,
                    type: 'get',
                    success: function (data) {
                        if (data.enableInThisCountry) {
                            $whatsApp.fadeIn();
                            $whatsApp.attr('href', data.overrideLink);
                        } else {
                            $whatsApp.remove();
                        }
                    },
                    error: function () {
                        $whatsApp.remove();
                    }
                });
            } else {
                $whatsApp.remove();
            }
        }
    }
    whatsappIntegration();
    $(document).on('whatsappIntegration', whatsappIntegration);
});

$(document).on('click', '.js-open-product-3d', function (e) {
    e.preventDefault();
    var link = $(this).parent().find('a.js-pdp-variant-link');
    var analytics = $(this).parent().find('.js-analytics-click-product');
    if (analytics.length > 0) {
        analytics.trigger('mousedown');
    }
    if (link.length > 0) {
        link.trigger('click');
    }
    window.location.href = $(this).data('href');
});


module.exports = {
};
